// This file is automatically generated. See gqlcodegen.yml for details
import { FieldPolicy, FieldReadFunction, TypePolicies, TypePolicy } from '@apollo/client/cache';
export type AccessLogKeySpecifier = ('accessLogID' | 'createdAt' | 'description' | 'entityIDs' | 'entityType' | 'requestID' | 'user' | AccessLogKeySpecifier)[];
export type AccessLogFieldPolicy = {
	accessLogID?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	entityIDs?: FieldPolicy<any> | FieldReadFunction<any>,
	entityType?: FieldPolicy<any> | FieldReadFunction<any>,
	requestID?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActionKeySpecifier = ('actionID' | 'actionValues' | ActionKeySpecifier)[];
export type ActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActionCountKeySpecifier = ('actionType' | 'count' | ActionCountKeySpecifier)[];
export type ActionCountFieldPolicy = {
	actionType?: FieldPolicy<any> | FieldReadFunction<any>,
	count?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActionProgressKeySpecifier = ('completed' | 'date' | 'total' | ActionProgressKeySpecifier)[];
export type ActionProgressFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	total?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActionTodosKeySpecifier = ('completed' | 'todo' | ActionTodosKeySpecifier)[];
export type ActionTodosFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	todo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActionValuesKeySpecifier = ('role' | 'timestamp' | ActionValuesKeySpecifier)[];
export type ActionValuesFieldPolicy = {
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityKeySpecifier = ('attendee' | 'endTime' | 'location' | 'notes' | 'startTime' | 'title' | ActivityKeySpecifier)[];
export type ActivityFieldPolicy = {
	attendee?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	location?: FieldPolicy<any> | FieldReadFunction<any>,
	notes?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityAddActionKeySpecifier = ('actionID' | 'actionValues' | 'activityPractice' | ActivityAddActionKeySpecifier)[];
export type ActivityAddActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	activityPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityDiaryWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | ActivityDiaryWidgetKeySpecifier)[];
export type ActivityDiaryWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityPracticeKeySpecifier = ('activity' | 'practiceID' | 'practiceValues' | ActivityPracticeKeySpecifier)[];
export type ActivityPracticeFieldPolicy = {
	activity?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ActivityRateActionKeySpecifier = ('actionID' | 'actionValues' | 'activityPractice' | ActivityRateActionKeySpecifier)[];
export type ActivityRateActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	activityPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddActionPayloadKeySpecifier = ('action' | AddActionPayloadKeySpecifier)[];
export type AddActionPayloadFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddActivityPracticePayloadKeySpecifier = ('activityPractice' | AddActivityPracticePayloadKeySpecifier)[];
export type AddActivityPracticePayloadFieldPolicy = {
	activityPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddHopeKitImagePayloadKeySpecifier = ('hopeKitImage' | 'uploadSession' | AddHopeKitImagePayloadKeySpecifier)[];
export type AddHopeKitImagePayloadFieldPolicy = {
	hopeKitImage?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddHopeKitQuotePayloadKeySpecifier = ('hopeKitQuote' | AddHopeKitQuotePayloadKeySpecifier)[];
export type AddHopeKitQuotePayloadFieldPolicy = {
	hopeKitQuote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddHopeKitVideoPayloadKeySpecifier = ('hopeKitVideo' | 'uploadSession' | AddHopeKitVideoPayloadKeySpecifier)[];
export type AddHopeKitVideoPayloadFieldPolicy = {
	hopeKitVideo?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddRelaxDiaryEntryPracticePayloadKeySpecifier = ('relaxDiaryEntryPractice' | AddRelaxDiaryEntryPracticePayloadKeySpecifier)[];
export type AddRelaxDiaryEntryPracticePayloadFieldPolicy = {
	relaxDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddSleepDiaryEntryPracticePayloadKeySpecifier = ('sleepDiaryEntryPractice' | AddSleepDiaryEntryPracticePayloadKeySpecifier)[];
export type AddSleepDiaryEntryPracticePayloadFieldPolicy = {
	sleepDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddThoughtDiaryEntryPracticePayloadKeySpecifier = ('thoughtDiaryEntryPractice' | AddThoughtDiaryEntryPracticePayloadKeySpecifier)[];
export type AddThoughtDiaryEntryPracticePayloadFieldPolicy = {
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AddressKeySpecifier = ('city' | 'line' | 'postalCode' | 'state' | 'use' | AddressKeySpecifier)[];
export type AddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	line?: FieldPolicy<any> | FieldReadFunction<any>,
	postalCode?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	use?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppActivityKeySpecifier = ('name' | 'params' | AppActivityKeySpecifier)[];
export type AppActivityFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	params?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AppVersionKeySpecifier = ('recommendedMinimumVersion' | 'requiredMinimumVersion' | AppVersionKeySpecifier)[];
export type AppVersionFieldPolicy = {
	recommendedMinimumVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	requiredMinimumVersion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ArtifactKeySpecifier = ('badge' | 'slug' | 'title' | ArtifactKeySpecifier)[];
export type ArtifactFieldPolicy = {
	badge?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AssetKeySpecifier = ('assetID' | 'context' | 'createdAt' | 'key' | 'userID' | AssetKeySpecifier)[];
export type AssetFieldPolicy = {
	assetID?: FieldPolicy<any> | FieldReadFunction<any>,
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	userID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type AvivaProfileKeySpecifier = ('productVariant' | AvivaProfileKeySpecifier)[];
export type AvivaProfileFieldPolicy = {
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BaseErrorKeySpecifier = ('message' | BaseErrorKeySpecifier)[];
export type BaseErrorFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BingeEatingMyPlanWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | BingeEatingMyPlanWidgetKeySpecifier)[];
export type BingeEatingMyPlanWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BotHistoryKeySpecifier = ('config' | 'createdAt' | 'envelope' | 'occurredAt' | BotHistoryKeySpecifier)[];
export type BotHistoryFieldPolicy = {
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	envelope?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BotStateKeySpecifier = ('botStateID' | 'config' | 'createdAt' | 'occurredAt' | 'state' | BotStateKeySpecifier)[];
export type BotStateFieldPolicy = {
	botStateID?: FieldPolicy<any> | FieldReadFunction<any>,
	config?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	occurredAt?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreathHoldingActionKeySpecifier = ('actionID' | 'actionValues' | BreathHoldingActionKeySpecifier)[];
export type BreathHoldingActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreathHoldingPracticeKeySpecifier = ('practiceID' | 'practiceValues' | 'stressBreathingExercise' | BreathHoldingPracticeKeySpecifier)[];
export type BreathHoldingPracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>,
	stressBreathingExercise?: FieldPolicy<any> | FieldReadFunction<any>
};
export type BreathHoldingWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'stressBreathingExerciseByID' | 'stressBreathingExercises' | 'unlockSession' | BreathHoldingWidgetKeySpecifier)[];
export type BreathHoldingWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	stressBreathingExerciseByID?: FieldPolicy<any> | FieldReadFunction<any>,
	stressBreathingExercises?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CMSAppKeySpecifier = ('appID' | 'logo' | 'logoID' | 'name' | 'variants' | CMSAppKeySpecifier)[];
export type CMSAppFieldPolicy = {
	appID?: FieldPolicy<any> | FieldReadFunction<any>,
	logo?: FieldPolicy<any> | FieldReadFunction<any>,
	logoID?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	variants?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CMSExchangeKeySpecifier = ('content' | 'exchangeID' | 'lastPatchVersion' | 'name' | CMSExchangeKeySpecifier)[];
export type CMSExchangeFieldPolicy = {
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	exchangeID?: FieldPolicy<any> | FieldReadFunction<any>,
	lastPatchVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CMSSessionKeySpecifier = ('agenda' | 'completedIllustration' | 'content' | 'contentType' | 'description' | 'group' | 'groupID' | 'illustration' | 'locale' | 'name' | 'order' | 'ordinal' | 'primaryExchange' | 'sessionID' | 'variant' | 'variantID' | CMSSessionKeySpecifier)[];
export type CMSSessionFieldPolicy = {
	agenda?: FieldPolicy<any> | FieldReadFunction<any>,
	completedIllustration?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	contentType?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	group?: FieldPolicy<any> | FieldReadFunction<any>,
	groupID?: FieldPolicy<any> | FieldReadFunction<any>,
	illustration?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	ordinal?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryExchange?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionID?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	variantID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CMSSessionGroupKeySpecifier = ('groupID' | 'name' | 'order' | 'sessions' | 'variant' | 'variantID' | CMSSessionGroupKeySpecifier)[];
export type CMSSessionGroupFieldPolicy = {
	groupID?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	order?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	variant?: FieldPolicy<any> | FieldReadFunction<any>,
	variantID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CMSVariantKeySpecifier = ('app' | 'appID' | 'groups' | 'name' | 'sessions' | 'variantID' | 'version' | CMSVariantKeySpecifier)[];
export type CMSVariantFieldPolicy = {
	app?: FieldPolicy<any> | FieldReadFunction<any>,
	appID?: FieldPolicy<any> | FieldReadFunction<any>,
	groups?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	variantID?: FieldPolicy<any> | FieldReadFunction<any>,
	version?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CareTeamKeySpecifier = ('ID' | 'organizations' | 'participants' | 'patient' | 'practitioners' | 'primaryPractitioner' | CareTeamKeySpecifier)[];
export type CareTeamFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	organizations?: FieldPolicy<any> | FieldReadFunction<any>,
	participants?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	practitioners?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryPractitioner?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ChangeBiteRoleSettingsKeySpecifier = ('sessionUnlockDayOfWeek' | ChangeBiteRoleSettingsKeySpecifier)[];
export type ChangeBiteRoleSettingsFieldPolicy = {
	sessionUnlockDayOfWeek?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompletedPatientQuizSetKeySpecifier = ('createdAt' | 'quizSetCompletionID' | 'quizSetID' | 'slug' | 'updatedAt' | CompletedPatientQuizSetKeySpecifier)[];
export type CompletedPatientQuizSetFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetCompletionID?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetID?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompletedPatientQuizSetsKeySpecifier = ('completedQuizSets' | 'patientID' | CompletedPatientQuizSetsKeySpecifier)[];
export type CompletedPatientQuizSetsFieldPolicy = {
	completedQuizSets?: FieldPolicy<any> | FieldReadFunction<any>,
	patientID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompositionKeySpecifier = ('ID' | 'author' | 'json' | 'patient' | 'sections' | 'title' | CompositionKeySpecifier)[];
export type CompositionFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	sections?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CompositionSectionKeySpecifier = ('ID' | 'createdAt' | 'json' | 'text' | 'title' | 'updatedAt' | CompositionSectionKeySpecifier)[];
export type CompositionSectionFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	json?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ContactPointKeySpecifier = ('ID' | 'system' | 'use' | 'value' | ContactPointKeySpecifier)[];
export type ContactPointFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	system?: FieldPolicy<any> | FieldReadFunction<any>,
	use?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopingCardAddActionKeySpecifier = ('actionID' | 'actionValues' | CopingCardAddActionKeySpecifier)[];
export type CopingCardAddActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopingCardReviewActionKeySpecifier = ('actionID' | 'actionValues' | CopingCardReviewActionKeySpecifier)[];
export type CopingCardReviewActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CopingCardsWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | CopingCardsWidgetKeySpecifier)[];
export type CopingCardsWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CreateTestScenarioResultKeySpecifier = ('organization' | 'users' | CreateTestScenarioResultKeySpecifier)[];
export type CreateTestScenarioResultFieldPolicy = {
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>
};
export type CurrentOuiUserKeySpecifier = ('attributes' | 'createdAt' | 'person' | 'primaryOrganization' | 'pushNotificationsDisabled' | 'role' | 'roles' | 'user' | 'userID' | 'username' | CurrentOuiUserKeySpecifier)[];
export type CurrentOuiUserFieldPolicy = {
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	pushNotificationsDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userID?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeletedRoleKeySpecifier = ('ID' | 'product' | 'productStatic' | 'roleLabel' | 'roleType' | DeletedRoleKeySpecifier)[];
export type DeletedRoleFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productStatic?: FieldPolicy<any> | FieldReadFunction<any>,
	roleLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	roleType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type DeviceKeySpecifier = ('installationID' | 'platform' | 'pushActive' | DeviceKeySpecifier)[];
export type DeviceFieldPolicy = {
	installationID?: FieldPolicy<any> | FieldReadFunction<any>,
	platform?: FieldPolicy<any> | FieldReadFunction<any>,
	pushActive?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingCheckinKeySpecifier = ('completionButtonClicked' | 'completionTimestamp' | 'mood' | 'promptTimestamp' | 'trigger' | 'urgeLevel' | EatingCheckinKeySpecifier)[];
export type EatingCheckinFieldPolicy = {
	completionButtonClicked?: FieldPolicy<any> | FieldReadFunction<any>,
	completionTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	mood?: FieldPolicy<any> | FieldReadFunction<any>,
	promptTimestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	trigger?: FieldPolicy<any> | FieldReadFunction<any>,
	urgeLevel?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingCheckinPracticeKeySpecifier = ('eatingCheckin' | 'practiceID' | 'practiceValues' | EatingCheckinPracticeKeySpecifier)[];
export type EatingCheckinPracticeFieldPolicy = {
	eatingCheckin?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingCommitmentEntryKeySpecifier = ('decreaseCommitment' | 'decreaseSuccess' | 'increaseCommitment' | 'increaseSuccess' | EatingCommitmentEntryKeySpecifier)[];
export type EatingCommitmentEntryFieldPolicy = {
	decreaseCommitment?: FieldPolicy<any> | FieldReadFunction<any>,
	decreaseSuccess?: FieldPolicy<any> | FieldReadFunction<any>,
	increaseCommitment?: FieldPolicy<any> | FieldReadFunction<any>,
	increaseSuccess?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingCommitmentEntryPracticeKeySpecifier = ('eatingCommitmentEntry' | 'practiceID' | 'practiceValues' | EatingCommitmentEntryPracticeKeySpecifier)[];
export type EatingCommitmentEntryPracticeFieldPolicy = {
	eatingCommitmentEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingLogAddActionKeySpecifier = ('actionID' | 'actionValues' | EatingLogAddActionKeySpecifier)[];
export type EatingLogAddActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingLogEntryKeySpecifier = ('binged' | 'description' | 'meal' | 'timestamp' | EatingLogEntryKeySpecifier)[];
export type EatingLogEntryFieldPolicy = {
	binged?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	meal?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingLogEntryPracticeKeySpecifier = ('eatingLogEntry' | 'imageUploadUrl' | 'imageUrl' | 'practiceID' | 'practiceValues' | EatingLogEntryPracticeKeySpecifier)[];
export type EatingLogEntryPracticeFieldPolicy = {
	eatingLogEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUploadUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	imageUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingLogWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | EatingLogWidgetKeySpecifier)[];
export type EatingLogWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingProgressEntryKeySpecifier = ('binges' | 'fadFixes' | 'timestamp' | 'weight' | 'weightUnit' | EatingProgressEntryKeySpecifier)[];
export type EatingProgressEntryFieldPolicy = {
	binges?: FieldPolicy<any> | FieldReadFunction<any>,
	fadFixes?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>,
	weight?: FieldPolicy<any> | FieldReadFunction<any>,
	weightUnit?: FieldPolicy<any> | FieldReadFunction<any>
};
export type EatingProgressEntryPracticeKeySpecifier = ('eatingProgressEntry' | 'practiceID' | 'practiceValues' | EatingProgressEntryPracticeKeySpecifier)[];
export type EatingProgressEntryPracticeFieldPolicy = {
	eatingProgressEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExchangePatchResultKeySpecifier = ('exchange' | 'success' | ExchangePatchResultKeySpecifier)[];
export type ExchangePatchResultFieldPolicy = {
	exchange?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ExchangePreviewKeySpecifier = ('exchangeID' | 'name' | ExchangePreviewKeySpecifier)[];
export type ExchangePreviewFieldPolicy = {
	exchangeID?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileUploadKeySpecifier = ('fileName' | 'fileUploadID' | 'fileUploadType' | 'gcsPath' | 'mimeType' | 'video' | FileUploadKeySpecifier)[];
export type FileUploadFieldPolicy = {
	fileName?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUploadID?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUploadType?: FieldPolicy<any> | FieldReadFunction<any>,
	gcsPath?: FieldPolicy<any> | FieldReadFunction<any>,
	mimeType?: FieldPolicy<any> | FieldReadFunction<any>,
	video?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileUploadActionKeySpecifier = ('action' | 'completedAt' | 'fileUploadID' | 'startedAt' | FileUploadActionKeySpecifier)[];
export type FileUploadActionFieldPolicy = {
	action?: FieldPolicy<any> | FieldReadFunction<any>,
	completedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUploadID?: FieldPolicy<any> | FieldReadFunction<any>,
	startedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type FileUploadSessionKeySpecifier = ('CMSUploadSessionURI' | 'fileUpload' | FileUploadSessionKeySpecifier)[];
export type FileUploadSessionFieldPolicy = {
	CMSUploadSessionURI?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUpload?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HopeKitAddActionKeySpecifier = ('actionID' | 'actionValues' | HopeKitAddActionKeySpecifier)[];
export type HopeKitAddActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HopeKitImageKeySpecifier = ('hopeKitItemID' | 'reason' | 'staticUrl' | 'url' | HopeKitImageKeySpecifier)[];
export type HopeKitImageFieldPolicy = {
	hopeKitItemID?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	staticUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HopeKitQuoteKeySpecifier = ('author' | 'hopeKitItemID' | 'reason' | 'text' | HopeKitQuoteKeySpecifier)[];
export type HopeKitQuoteFieldPolicy = {
	author?: FieldPolicy<any> | FieldReadFunction<any>,
	hopeKitItemID?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HopeKitReviewActionKeySpecifier = ('actionID' | 'actionValues' | HopeKitReviewActionKeySpecifier)[];
export type HopeKitReviewActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HopeKitVideoKeySpecifier = ('hopeKitItemID' | 'reason' | 'staticUrl' | 'url' | HopeKitVideoKeySpecifier)[];
export type HopeKitVideoFieldPolicy = {
	hopeKitItemID?: FieldPolicy<any> | FieldReadFunction<any>,
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	staticUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HopeKitWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'items' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | HopeKitWidgetKeySpecifier)[];
export type HopeKitWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HyperventilationActionKeySpecifier = ('actionID' | 'actionValues' | HyperventilationActionKeySpecifier)[];
export type HyperventilationActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HyperventilationPracticeKeySpecifier = ('practiceID' | 'practiceValues' | 'stressBreathingExercise' | HyperventilationPracticeKeySpecifier)[];
export type HyperventilationPracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>,
	stressBreathingExercise?: FieldPolicy<any> | FieldReadFunction<any>
};
export type HyperventilationWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'stressBreathingExerciseByID' | 'stressBreathingExercises' | 'unlockSession' | HyperventilationWidgetKeySpecifier)[];
export type HyperventilationWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	stressBreathingExerciseByID?: FieldPolicy<any> | FieldReadFunction<any>,
	stressBreathingExercises?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type IPatientProfileKeySpecifier = ('ID' | 'careTeam' | 'devices' | 'emails' | 'lastLogin' | 'notifications' | 'patient' | 'progress' | 'role' | 'supportees' | 'supporters' | IPatientProfileKeySpecifier)[];
export type IPatientProfileFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	careTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	emails?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	supportees?: FieldPolicy<any> | FieldReadFunction<any>,
	supporters?: FieldPolicy<any> | FieldReadFunction<any>
};
export type InvalidPasswordErrorKeySpecifier = ('message' | InvalidPasswordErrorKeySpecifier)[];
export type InvalidPasswordErrorFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type JobKeySpecifier = ('ID' | 'createdAt' | 'result' | 'scheduledAt' | 'status' | 'type' | 'updatedAt' | JobKeySpecifier)[];
export type JobFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	result?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type KVResponseKeySpecifier = ('context' | 'key' | 'value' | KVResponseKeySpecifier)[];
export type KVResponseFieldPolicy = {
	context?: FieldPolicy<any> | FieldReadFunction<any>,
	key?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LatLngKeySpecifier = ('lat' | 'lng' | LatLngKeySpecifier)[];
export type LatLngFieldPolicy = {
	lat?: FieldPolicy<any> | FieldReadFunction<any>,
	lng?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyQuizSetItemMultipleChoiceQuestionKeySpecifier = ('dir' | 'props' | LegacyQuizSetItemMultipleChoiceQuestionKeySpecifier)[];
export type LegacyQuizSetItemMultipleChoiceQuestionFieldPolicy = {
	dir?: FieldPolicy<any> | FieldReadFunction<any>,
	props?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyQuizSetItemSingleChoiceQuestionKeySpecifier = ('dir' | 'props' | LegacyQuizSetItemSingleChoiceQuestionKeySpecifier)[];
export type LegacyQuizSetItemSingleChoiceQuestionFieldPolicy = {
	dir?: FieldPolicy<any> | FieldReadFunction<any>,
	props?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyQuizSetItemVideoKeySpecifier = ('props' | LegacyQuizSetItemVideoKeySpecifier)[];
export type LegacyQuizSetItemVideoFieldPolicy = {
	props?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyQuizSetItemVideoPropsKeySpecifier = ('compulsory' | 'title' | 'url' | LegacyQuizSetItemVideoPropsKeySpecifier)[];
export type LegacyQuizSetItemVideoPropsFieldPolicy = {
	compulsory?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LegacyUserKeySpecifier = ('ID' | 'address' | 'demo' | 'email' | 'name' | 'phone' | LegacyUserKeySpecifier)[];
export type LegacyUserFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	demo?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>
};
export type LessonLearnedKeySpecifier = ('createdAt' | 'session' | 'text' | LessonLearnedKeySpecifier)[];
export type LessonLearnedFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	session?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MostCompletedKeySpecifier = ('day' | 'practiceCount' | 'sessionCount' | MostCompletedKeySpecifier)[];
export type MostCompletedFieldPolicy = {
	day?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationKeySpecifier = ('acceptYstNomination' | 'addAction' | 'addActivityPractice' | 'addBreathHoldingPractice' | 'addEatingCheckin' | 'addEatingLogEntry' | 'addEatingProgressEntry' | 'addHopeKitImage' | 'addHopeKitQuote' | 'addHopeKitVideo' | 'addHyperventilationPractice' | 'addOrganization' | 'addOrganizationMember' | 'addOrganizationProduct' | 'addPatient' | 'addPatientSupporter' | 'addPractitioner' | 'addPractitionerToCareTeam' | 'addRelaxDiaryEntry' | 'addSleepDiaryEntry' | 'addThoughtDiaryEntry' | 'addWordPairingPractice' | 'addYstSupporterEvent' | 'completeFileUploadAction' | 'completeQuizSetForPatient' | 'contactYstSupport' | 'copyQuizSetToCollection' | 'copySession' | 'createApp' | 'createFileUpload' | 'createJob' | 'createQuizSet' | 'createQuizSetCollection' | 'createQuizSetItemChoice' | 'createQuizSetItemVideo' | 'createSession' | 'createSessionGroup' | 'createTestScenario' | 'createTestUser' | 'createUser' | 'createVariant' | 'createVideo' | 'deactivateUser' | 'declineYstNomination' | 'deleteActivityPractice' | 'deleteEatingLogEntry' | 'deleteOrganizationProduct' | 'deleteQuizSet' | 'deleteQuizSetItem' | 'deleteSession' | 'deleteSessionGroup' | 'deleteThoughtDiaryEntry' | 'inviteYSTGuardian' | 'inviteYSTYouth' | 'issueToken' | 'issueTokenByEmail' | 'issueTokenForPractitioner' | 'issueTokenForRegistrar' | 'issueTokenLinkForSupporter' | 'issueYSTYouthInviteLink' | 'issueYSTYouthInviteMessage' | 'kvRespond' | 'login' | 'loginWithEmail' | 'loginWithToken' | 'logoutDevice' | 'newCompositionWithTemplate' | 'nominateYstSupporters' | 'patchExchange' | 'persistBotState' | 'previewYstPatientMessage' | 'rateYstSupporterCheckin' | 'reauthenticate' | 'removeHopeKitItem' | 'removePatientSupporter' | 'removePractitionerFromCareTeam' | 'replacePrimaryPractitioner' | 'resendYstNominationInvite' | 'resendYstPatientMessage' | 'respond' | 'reviewPatientSupporter' | 'rewindBotState' | 'setCareTeamPrimaryPractitioner' | 'setComposition' | 'setDevice' | 'setOuiProgress' | 'setOuiProgressForPatient' | 'setPatientSupporterRelation' | 'setPushNotificationsDisabled' | 'signupYSTGuardian' | 'signupYSTYouth' | 'snapshotQuizSetCollection' | 'snapshotSession' | 'softDeleteOutdatedBotHistory' | 'throwError' | 'throwPanic' | 'updateActivityPractice' | 'updateApp' | 'updateBreathHoldingPractice' | 'updateComposition' | 'updateCompositionSection' | 'updateEatingCheckin' | 'updateEatingLogEntry' | 'updateEatingProgressEntry' | 'updateFirstCheckinDate' | 'updateHopeKitImage' | 'updateHopeKitQuote' | 'updateHopeKitVideo' | 'updateHyperventilationPractice' | 'updateInfo' | 'updateOnboardingAvailability' | 'updateOrganization' | 'updateOrganizationMember' | 'updateOrganizationProduct' | 'updateOuiUser' | 'updateOuiUserWithToken' | 'updatePatient' | 'updatePractice' | 'updateQuizSet' | 'updateQuizSetCollection' | 'updateQuizSetItemChoice' | 'updateQuizSetItemOrder' | 'updateRecurringAvailability' | 'updateRelaxDiaryEntry' | 'updateRoleSettings' | 'updateSession' | 'updateSessionGroup' | 'updateSleepDiaryEntry' | 'updateThoughtDiaryEntry' | 'updateUser' | 'updateVariant' | 'updateWordPairingPractice' | 'updateYstMentalHealthConcerns' | 'updateYstSupporterEvent' | 'uploadResumableAsset' | MutationKeySpecifier)[];
export type MutationFieldPolicy = {
	acceptYstNomination?: FieldPolicy<any> | FieldReadFunction<any>,
	addAction?: FieldPolicy<any> | FieldReadFunction<any>,
	addActivityPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	addBreathHoldingPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	addEatingCheckin?: FieldPolicy<any> | FieldReadFunction<any>,
	addEatingLogEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addEatingProgressEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addHopeKitImage?: FieldPolicy<any> | FieldReadFunction<any>,
	addHopeKitQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	addHopeKitVideo?: FieldPolicy<any> | FieldReadFunction<any>,
	addHyperventilationPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	addOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	addOrganizationMember?: FieldPolicy<any> | FieldReadFunction<any>,
	addOrganizationProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	addPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	addPatientSupporter?: FieldPolicy<any> | FieldReadFunction<any>,
	addPractitioner?: FieldPolicy<any> | FieldReadFunction<any>,
	addPractitionerToCareTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	addRelaxDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addSleepDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addThoughtDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	addWordPairingPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	addYstSupporterEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	completeFileUploadAction?: FieldPolicy<any> | FieldReadFunction<any>,
	completeQuizSetForPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	contactYstSupport?: FieldPolicy<any> | FieldReadFunction<any>,
	copyQuizSetToCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	copySession?: FieldPolicy<any> | FieldReadFunction<any>,
	createApp?: FieldPolicy<any> | FieldReadFunction<any>,
	createFileUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	createJob?: FieldPolicy<any> | FieldReadFunction<any>,
	createQuizSet?: FieldPolicy<any> | FieldReadFunction<any>,
	createQuizSetCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	createQuizSetItemChoice?: FieldPolicy<any> | FieldReadFunction<any>,
	createQuizSetItemVideo?: FieldPolicy<any> | FieldReadFunction<any>,
	createSession?: FieldPolicy<any> | FieldReadFunction<any>,
	createSessionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	createTestScenario?: FieldPolicy<any> | FieldReadFunction<any>,
	createTestUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createUser?: FieldPolicy<any> | FieldReadFunction<any>,
	createVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	createVideo?: FieldPolicy<any> | FieldReadFunction<any>,
	deactivateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	declineYstNomination?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteActivityPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteEatingLogEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteOrganizationProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteQuizSet?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteQuizSetItem?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSession?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteSessionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	deleteThoughtDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteYSTGuardian?: FieldPolicy<any> | FieldReadFunction<any>,
	inviteYSTYouth?: FieldPolicy<any> | FieldReadFunction<any>,
	issueToken?: FieldPolicy<any> | FieldReadFunction<any>,
	issueTokenByEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	issueTokenForPractitioner?: FieldPolicy<any> | FieldReadFunction<any>,
	issueTokenForRegistrar?: FieldPolicy<any> | FieldReadFunction<any>,
	issueTokenLinkForSupporter?: FieldPolicy<any> | FieldReadFunction<any>,
	issueYSTYouthInviteLink?: FieldPolicy<any> | FieldReadFunction<any>,
	issueYSTYouthInviteMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	kvRespond?: FieldPolicy<any> | FieldReadFunction<any>,
	login?: FieldPolicy<any> | FieldReadFunction<any>,
	loginWithEmail?: FieldPolicy<any> | FieldReadFunction<any>,
	loginWithToken?: FieldPolicy<any> | FieldReadFunction<any>,
	logoutDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	newCompositionWithTemplate?: FieldPolicy<any> | FieldReadFunction<any>,
	nominateYstSupporters?: FieldPolicy<any> | FieldReadFunction<any>,
	patchExchange?: FieldPolicy<any> | FieldReadFunction<any>,
	persistBotState?: FieldPolicy<any> | FieldReadFunction<any>,
	previewYstPatientMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	rateYstSupporterCheckin?: FieldPolicy<any> | FieldReadFunction<any>,
	reauthenticate?: FieldPolicy<any> | FieldReadFunction<any>,
	removeHopeKitItem?: FieldPolicy<any> | FieldReadFunction<any>,
	removePatientSupporter?: FieldPolicy<any> | FieldReadFunction<any>,
	removePractitionerFromCareTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	replacePrimaryPractitioner?: FieldPolicy<any> | FieldReadFunction<any>,
	resendYstNominationInvite?: FieldPolicy<any> | FieldReadFunction<any>,
	resendYstPatientMessage?: FieldPolicy<any> | FieldReadFunction<any>,
	respond?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewPatientSupporter?: FieldPolicy<any> | FieldReadFunction<any>,
	rewindBotState?: FieldPolicy<any> | FieldReadFunction<any>,
	setCareTeamPrimaryPractitioner?: FieldPolicy<any> | FieldReadFunction<any>,
	setComposition?: FieldPolicy<any> | FieldReadFunction<any>,
	setDevice?: FieldPolicy<any> | FieldReadFunction<any>,
	setOuiProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	setOuiProgressForPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	setPatientSupporterRelation?: FieldPolicy<any> | FieldReadFunction<any>,
	setPushNotificationsDisabled?: FieldPolicy<any> | FieldReadFunction<any>,
	signupYSTGuardian?: FieldPolicy<any> | FieldReadFunction<any>,
	signupYSTYouth?: FieldPolicy<any> | FieldReadFunction<any>,
	snapshotQuizSetCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	snapshotSession?: FieldPolicy<any> | FieldReadFunction<any>,
	softDeleteOutdatedBotHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	throwError?: FieldPolicy<any> | FieldReadFunction<any>,
	throwPanic?: FieldPolicy<any> | FieldReadFunction<any>,
	updateActivityPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateApp?: FieldPolicy<any> | FieldReadFunction<any>,
	updateBreathHoldingPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateComposition?: FieldPolicy<any> | FieldReadFunction<any>,
	updateCompositionSection?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEatingCheckin?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEatingLogEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateEatingProgressEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateFirstCheckinDate?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHopeKitImage?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHopeKitQuote?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHopeKitVideo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateHyperventilationPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateInfo?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOnboardingAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrganizationMember?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOrganizationProduct?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOuiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateOuiUserWithToken?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePatient?: FieldPolicy<any> | FieldReadFunction<any>,
	updatePractice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateQuizSet?: FieldPolicy<any> | FieldReadFunction<any>,
	updateQuizSetCollection?: FieldPolicy<any> | FieldReadFunction<any>,
	updateQuizSetItemChoice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateQuizSetItemOrder?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRecurringAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRelaxDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateRoleSettings?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSession?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSessionGroup?: FieldPolicy<any> | FieldReadFunction<any>,
	updateSleepDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateThoughtDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>,
	updateUser?: FieldPolicy<any> | FieldReadFunction<any>,
	updateVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	updateWordPairingPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	updateYstMentalHealthConcerns?: FieldPolicy<any> | FieldReadFunction<any>,
	updateYstSupporterEvent?: FieldPolicy<any> | FieldReadFunction<any>,
	uploadResumableAsset?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationNominateYstSupportersSuccessKeySpecifier = ('data' | MutationNominateYstSupportersSuccessKeySpecifier)[];
export type MutationNominateYstSupportersSuccessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationResendYstPatientMessageSuccessKeySpecifier = ('data' | MutationResendYstPatientMessageSuccessKeySpecifier)[];
export type MutationResendYstPatientMessageSuccessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationUpdateFirstCheckinDateSuccessKeySpecifier = ('data' | MutationUpdateFirstCheckinDateSuccessKeySpecifier)[];
export type MutationUpdateFirstCheckinDateSuccessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationUpdateOnboardingAvailabilitySuccessKeySpecifier = ('data' | MutationUpdateOnboardingAvailabilitySuccessKeySpecifier)[];
export type MutationUpdateOnboardingAvailabilitySuccessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationUpdateRecurringAvailabilitySuccessKeySpecifier = ('data' | MutationUpdateRecurringAvailabilitySuccessKeySpecifier)[];
export type MutationUpdateRecurringAvailabilitySuccessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MutationUpdateYstMentalHealthConcernsSuccessKeySpecifier = ('data' | MutationUpdateYstMentalHealthConcernsSuccessKeySpecifier)[];
export type MutationUpdateYstMentalHealthConcernsSuccessFieldPolicy = {
	data?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MyPlanReviewActionKeySpecifier = ('actionID' | 'actionValues' | MyPlanReviewActionKeySpecifier)[];
export type MyPlanReviewActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type MyPlanWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'suicideMode' | 'unlockSession' | MyPlanWidgetKeySpecifier)[];
export type MyPlanWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	suicideMode?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationKeySpecifier = ('ID' | 'caringContactsEnabled' | 'children' | 'isTrialOrganization' | 'lastPatientCreatedAt' | 'members' | 'name' | 'onboardingVariant' | 'parent' | 'practitioners' | 'productVariants' | 'productVersion' | 'products' | 'registrars' | 'stats' | OrganizationKeySpecifier)[];
export type OrganizationFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	caringContactsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	children?: FieldPolicy<any> | FieldReadFunction<any>,
	isTrialOrganization?: FieldPolicy<any> | FieldReadFunction<any>,
	lastPatientCreatedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	members?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	parent?: FieldPolicy<any> | FieldReadFunction<any>,
	practitioners?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariants?: FieldPolicy<any> | FieldReadFunction<any>,
	productVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	registrars?: FieldPolicy<any> | FieldReadFunction<any>,
	stats?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationAvivaConfigKeySpecifier = ('caringContactsEnabled' | 'crisisFramework' | 'onboardingVariant' | 'productVersion' | OrganizationAvivaConfigKeySpecifier)[];
export type OrganizationAvivaConfigFieldPolicy = {
	caringContactsEnabled?: FieldPolicy<any> | FieldReadFunction<any>,
	crisisFramework?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	productVersion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationMemberKeySpecifier = ('organizationID' | 'person' | 'roles' | 'userID' | 'userRoles' | OrganizationMemberKeySpecifier)[];
export type OrganizationMemberFieldPolicy = {
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	userID?: FieldPolicy<any> | FieldReadFunction<any>,
	userRoles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationMemberResultKeySpecifier = ('member' | OrganizationMemberResultKeySpecifier)[];
export type OrganizationMemberResultFieldPolicy = {
	member?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationProductKeySpecifier = ('name' | 'nameStatic' | 'product' | 'productConfig' | OrganizationProductKeySpecifier)[];
export type OrganizationProductFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nameStatic?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productConfig?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationStatsKeySpecifier = ('patientCount' | 'practitionerCount' | 'registrarCount' | OrganizationStatsKeySpecifier)[];
export type OrganizationStatsFieldPolicy = {
	patientCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practitionerCount?: FieldPolicy<any> | FieldReadFunction<any>,
	registrarCount?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OrganizationYstConfigKeySpecifier = ('contacts' | 'slug' | 'unlisted' | OrganizationYstConfigKeySpecifier)[];
export type OrganizationYstConfigFieldPolicy = {
	contacts?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	unlisted?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OuiAdminKeySpecifier = ('ID' | 'person' | OuiAdminKeySpecifier)[];
export type OuiAdminFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OuiProgressKeySpecifier = ('completed' | 'completion' | 'content' | 'session' | 'updatedAt' | OuiProgressKeySpecifier)[];
export type OuiProgressFieldPolicy = {
	completed?: FieldPolicy<any> | FieldReadFunction<any>,
	completion?: FieldPolicy<any> | FieldReadFunction<any>,
	content?: FieldPolicy<any> | FieldReadFunction<any>,
	session?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OuiUserKeySpecifier = ('createdAt' | 'devices' | 'disabled' | 'person' | 'products' | 'roles' | 'roles2' | 'userID' | 'username' | OuiUserKeySpecifier)[];
export type OuiUserFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	disabled?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	roles2?: FieldPolicy<any> | FieldReadFunction<any>,
	userID?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OuiUserAttributesKeySpecifier = ('admin' | 'testUser' | 'trialAuditor' | OuiUserAttributesKeySpecifier)[];
export type OuiUserAttributesFieldPolicy = {
	admin?: FieldPolicy<any> | FieldReadFunction<any>,
	testUser?: FieldPolicy<any> | FieldReadFunction<any>,
	trialAuditor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OuiUserProductKeySpecifier = ('product' | 'roles' | OuiUserProductKeySpecifier)[];
export type OuiUserProductFieldPolicy = {
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OuiUserRoleKeySpecifier = ('ID' | 'organization' | 'role' | 'roleLabel' | 'user' | OuiUserRoleKeySpecifier)[];
export type OuiUserRoleFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roleLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type OutdatedBotStateErrorKeySpecifier = ('message' | OutdatedBotStateErrorKeySpecifier)[];
export type OutdatedBotStateErrorFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientKeySpecifier = ('ID' | 'address' | 'avivaProfile' | 'birthDate' | 'careTeam' | 'caringContactsMedium' | 'createdAt' | 'devices' | 'emails' | 'genderIdentity' | 'lastLogin' | 'militaryStatus' | 'notifications' | 'onboardingVariant' | 'patient' | 'person' | 'productStatic' | 'productVariant' | 'productVersion' | 'profile' | 'progress' | 'race' | 'role' | 'sexualOrientation' | 'supportees' | 'supporters' | 'ystGuardianProfile' | 'ystProfile' | 'ystSupportProfile' | 'ystYouthProfile' | PatientKeySpecifier)[];
export type PatientFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	avivaProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	birthDate?: FieldPolicy<any> | FieldReadFunction<any>,
	careTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	caringContactsMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	emails?: FieldPolicy<any> | FieldReadFunction<any>,
	genderIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	militaryStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>,
	productStatic?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	productVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	profile?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	race?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	sexualOrientation?: FieldPolicy<any> | FieldReadFunction<any>,
	supportees?: FieldPolicy<any> | FieldReadFunction<any>,
	supporters?: FieldPolicy<any> | FieldReadFunction<any>,
	ystGuardianProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	ystProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	ystSupportProfile?: FieldPolicy<any> | FieldReadFunction<any>,
	ystYouthProfile?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientCaringContactKeySpecifier = ('caringContactID' | 'caringContactsMedium' | 'createdAt' | 'templateKey' | 'thirdPartyServiceID' | PatientCaringContactKeySpecifier)[];
export type PatientCaringContactFieldPolicy = {
	caringContactID?: FieldPolicy<any> | FieldReadFunction<any>,
	caringContactsMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	templateKey?: FieldPolicy<any> | FieldReadFunction<any>,
	thirdPartyServiceID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientNotificationKeySpecifier = ('createdAt' | 'notificationID' | 'rule' | 'variation' | PatientNotificationKeySpecifier)[];
export type PatientNotificationFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	notificationID?: FieldPolicy<any> | FieldReadFunction<any>,
	rule?: FieldPolicy<any> | FieldReadFunction<any>,
	variation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientProfileKeySpecifier = ('ID' | 'careTeam' | 'caringContacts' | 'devices' | 'emails' | 'lastLogin' | 'myPlanComposition' | 'notifications' | 'patient' | 'progress' | 'role' | 'supportees' | 'supporters' | PatientProfileKeySpecifier)[];
export type PatientProfileFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	careTeam?: FieldPolicy<any> | FieldReadFunction<any>,
	caringContacts?: FieldPolicy<any> | FieldReadFunction<any>,
	devices?: FieldPolicy<any> | FieldReadFunction<any>,
	emails?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	myPlanComposition?: FieldPolicy<any> | FieldReadFunction<any>,
	notifications?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	supportees?: FieldPolicy<any> | FieldReadFunction<any>,
	supporters?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientQuizSetCompletedKeySpecifier = ('completedQuizSet' | 'patientID' | PatientQuizSetCompletedKeySpecifier)[];
export type PatientQuizSetCompletedFieldPolicy = {
	completedQuizSet?: FieldPolicy<any> | FieldReadFunction<any>,
	patientID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientSupportLinkDetailsKeySpecifier = ('patientName' | 'relation' | PatientSupportLinkDetailsKeySpecifier)[];
export type PatientSupportLinkDetailsFieldPolicy = {
	patientName?: FieldPolicy<any> | FieldReadFunction<any>,
	relation?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PatientSupporterKeySpecifier = ('ID' | 'claimed' | 'patient' | 'patientID' | 'relation' | 'reviewed' | 'roleSupportee' | 'roleSupporter' | 'supporter' | 'supporterID' | PatientSupporterKeySpecifier)[];
export type PatientSupporterFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	claimed?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	patientID?: FieldPolicy<any> | FieldReadFunction<any>,
	relation?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewed?: FieldPolicy<any> | FieldReadFunction<any>,
	roleSupportee?: FieldPolicy<any> | FieldReadFunction<any>,
	roleSupporter?: FieldPolicy<any> | FieldReadFunction<any>,
	supporter?: FieldPolicy<any> | FieldReadFunction<any>,
	supporterID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingActionKeySpecifier = ('pendingActionID' | PendingActionKeySpecifier)[];
export type PendingActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingActivityAddActionKeySpecifier = ('pendingActionID' | PendingActivityAddActionKeySpecifier)[];
export type PendingActivityAddActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingActivityRateActionKeySpecifier = ('activityPractice' | 'pendingActionID' | PendingActivityRateActionKeySpecifier)[];
export type PendingActivityRateActionFieldPolicy = {
	activityPractice?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingBreathHoldingActionKeySpecifier = ('pendingActionID' | PendingBreathHoldingActionKeySpecifier)[];
export type PendingBreathHoldingActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingCopingCardAddActionKeySpecifier = ('pendingActionID' | PendingCopingCardAddActionKeySpecifier)[];
export type PendingCopingCardAddActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingCopingCardReviewActionKeySpecifier = ('pendingActionID' | PendingCopingCardReviewActionKeySpecifier)[];
export type PendingCopingCardReviewActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingEatingLogAddActionKeySpecifier = ('pendingActionID' | PendingEatingLogAddActionKeySpecifier)[];
export type PendingEatingLogAddActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingHopeKitAddActionKeySpecifier = ('pendingActionID' | PendingHopeKitAddActionKeySpecifier)[];
export type PendingHopeKitAddActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingHopeKitReviewActionKeySpecifier = ('pendingActionID' | PendingHopeKitReviewActionKeySpecifier)[];
export type PendingHopeKitReviewActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingHyperventilationActionKeySpecifier = ('pendingActionID' | PendingHyperventilationActionKeySpecifier)[];
export type PendingHyperventilationActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingMyPlanReviewActionKeySpecifier = ('pendingActionID' | PendingMyPlanReviewActionKeySpecifier)[];
export type PendingMyPlanReviewActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingRelaxActionKeySpecifier = ('pendingActionID' | PendingRelaxActionKeySpecifier)[];
export type PendingRelaxActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingSleepDiaryEntryMorningActionKeySpecifier = ('date' | 'pendingActionID' | PendingSleepDiaryEntryMorningActionKeySpecifier)[];
export type PendingSleepDiaryEntryMorningActionFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingSleepDiaryEntryNightActionKeySpecifier = ('date' | 'pendingActionID' | PendingSleepDiaryEntryNightActionKeySpecifier)[];
export type PendingSleepDiaryEntryNightActionFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingThoughtDiaryEntrySpotActionKeySpecifier = ('pendingActionID' | PendingThoughtDiaryEntrySpotActionKeySpecifier)[];
export type PendingThoughtDiaryEntrySpotActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingThoughtDiaryEntrySwitchActionKeySpecifier = ('pendingActionID' | 'thoughtDiaryEntryPractice' | PendingThoughtDiaryEntrySwitchActionKeySpecifier)[];
export type PendingThoughtDiaryEntrySwitchActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingThoughtDiaryEntryTestActionKeySpecifier = ('pendingActionID' | 'thoughtDiaryEntryPractice' | PendingThoughtDiaryEntryTestActionKeySpecifier)[];
export type PendingThoughtDiaryEntryTestActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PendingWordPairingActionKeySpecifier = ('pendingActionID' | PendingWordPairingActionKeySpecifier)[];
export type PendingWordPairingActionFieldPolicy = {
	pendingActionID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PersonKeySpecifier = ('address' | 'birthDate' | 'contactPoint' | 'email' | 'familyName' | 'genderIdentity' | 'givenName' | 'lastLogin' | 'militaryStatus' | 'ouiUser' | 'passwordSetAt' | 'phone' | 'race' | 'settings' | 'sexualOrientation' | 'timezone' | 'userID' | PersonKeySpecifier)[];
export type PersonFieldPolicy = {
	address?: FieldPolicy<any> | FieldReadFunction<any>,
	birthDate?: FieldPolicy<any> | FieldReadFunction<any>,
	contactPoint?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	familyName?: FieldPolicy<any> | FieldReadFunction<any>,
	genderIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	givenName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	militaryStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	ouiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordSetAt?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	race?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	sexualOrientation?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	userID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceAutocompleteKeySpecifier = ('description' | 'matchedSubstrings' | 'placeId' | 'structuredFormatting' | PlaceAutocompleteKeySpecifier)[];
export type PlaceAutocompleteFieldPolicy = {
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	matchedSubstrings?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>,
	structuredFormatting?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceDetailsKeySpecifier = ('formattedAddress' | 'geometry' | 'name' | 'placeId' | PlaceDetailsKeySpecifier)[];
export type PlaceDetailsFieldPolicy = {
	formattedAddress?: FieldPolicy<any> | FieldReadFunction<any>,
	geometry?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	placeId?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceGeometryKeySpecifier = ('location' | PlaceGeometryKeySpecifier)[];
export type PlaceGeometryFieldPolicy = {
	location?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PlaceStructuredFormattingKeySpecifier = ('mainText' | 'secondaryText' | PlaceStructuredFormattingKeySpecifier)[];
export type PlaceStructuredFormattingFieldPolicy = {
	mainText?: FieldPolicy<any> | FieldReadFunction<any>,
	secondaryText?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PracticeKeySpecifier = ('practiceID' | 'practiceValues' | PracticeKeySpecifier)[];
export type PracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PracticeRatingKeySpecifier = ('type' | 'value' | PracticeRatingKeySpecifier)[];
export type PracticeRatingFieldPolicy = {
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PracticeRatingIntervalKeySpecifier = ('practiceRating' | 'startDate' | PracticeRatingIntervalKeySpecifier)[];
export type PracticeRatingIntervalFieldPolicy = {
	practiceRating?: FieldPolicy<any> | FieldReadFunction<any>,
	startDate?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PracticeValuesKeySpecifier = ('date' | 'patient' | 'ratings' | 'role' | PracticeValuesKeySpecifier)[];
export type PracticeValuesFieldPolicy = {
	date?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	ratings?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PractitionerKeySpecifier = ('ID' | 'npi' | 'person' | PractitionerKeySpecifier)[];
export type PractitionerFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	npi?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>
};
export type PresenceKeySpecifier = ('connected' | 'timestamp' | PresenceKeySpecifier)[];
export type PresenceFieldPolicy = {
	connected?: FieldPolicy<any> | FieldReadFunction<any>,
	timestamp?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductKeySpecifier = ('ID' | 'iconUrl' | 'logoUrl' | 'name' | 'roleTypes' | 'slug' | 'staticEnabled' | ProductKeySpecifier)[];
export type ProductFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	iconUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	logoUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	roleTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	staticEnabled?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ProductRoleTypeKeySpecifier = ('cmsVariant' | 'name' | 'roleType' | ProductRoleTypeKeySpecifier)[];
export type ProductRoleTypeFieldPolicy = {
	cmsVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	roleType?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QueryKeySpecifier = ('accessLogsByUser' | 'accessLogsForEntity' | 'actionCounts' | 'actionProgresses' | 'actionTodos' | 'activityPracticeByID' | 'appByID' | 'apps' | 'asset' | 'botConfigState' | 'botHistory' | 'careTeamByPatientID' | 'completedQuizSetsForPatient' | 'compositionByID' | 'compositions' | 'currentUser' | 'currentYstPatient' | 'fileUploadByID' | 'fileUploads' | 'hopeKitItems' | 'jobByID' | 'jobs' | 'kvResponse' | 'lessonLearned' | 'minimumAppVersion' | 'organizationByID' | 'organizations' | 'ouiUser' | 'ouiUserEmailWithToken' | 'patientByPatientID' | 'patientSupporterLinkDetails' | 'patients' | 'placeAutocomplete' | 'placeDetails' | 'practiceRatings' | 'practices' | 'productVariantAssignmentsForTrial' | 'products' | 'quizSetCollectionByID' | 'quizSetCollections' | 'relaxDiaryConfig' | 'relaxDiaryEntryCounts' | 'sessionByID' | 'sessionGroupByID' | 'sleepDiaryEntryPracticeByDate' | 'sleepDiaryEntryPracticeByID' | 'thoughtDiaryEntryPracticeByID' | 'treatmentV2' | 'user' | 'userByID' | 'users' | 'variantByID' | 'ystOrganizationBySlug' | 'ystOrganizations' | QueryKeySpecifier)[];
export type QueryFieldPolicy = {
	accessLogsByUser?: FieldPolicy<any> | FieldReadFunction<any>,
	accessLogsForEntity?: FieldPolicy<any> | FieldReadFunction<any>,
	actionCounts?: FieldPolicy<any> | FieldReadFunction<any>,
	actionProgresses?: FieldPolicy<any> | FieldReadFunction<any>,
	actionTodos?: FieldPolicy<any> | FieldReadFunction<any>,
	activityPracticeByID?: FieldPolicy<any> | FieldReadFunction<any>,
	appByID?: FieldPolicy<any> | FieldReadFunction<any>,
	apps?: FieldPolicy<any> | FieldReadFunction<any>,
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	botConfigState?: FieldPolicy<any> | FieldReadFunction<any>,
	botHistory?: FieldPolicy<any> | FieldReadFunction<any>,
	careTeamByPatientID?: FieldPolicy<any> | FieldReadFunction<any>,
	completedQuizSetsForPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	compositionByID?: FieldPolicy<any> | FieldReadFunction<any>,
	compositions?: FieldPolicy<any> | FieldReadFunction<any>,
	currentUser?: FieldPolicy<any> | FieldReadFunction<any>,
	currentYstPatient?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUploadByID?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUploads?: FieldPolicy<any> | FieldReadFunction<any>,
	hopeKitItems?: FieldPolicy<any> | FieldReadFunction<any>,
	jobByID?: FieldPolicy<any> | FieldReadFunction<any>,
	jobs?: FieldPolicy<any> | FieldReadFunction<any>,
	kvResponse?: FieldPolicy<any> | FieldReadFunction<any>,
	lessonLearned?: FieldPolicy<any> | FieldReadFunction<any>,
	minimumAppVersion?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationByID?: FieldPolicy<any> | FieldReadFunction<any>,
	organizations?: FieldPolicy<any> | FieldReadFunction<any>,
	ouiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	ouiUserEmailWithToken?: FieldPolicy<any> | FieldReadFunction<any>,
	patientByPatientID?: FieldPolicy<any> | FieldReadFunction<any>,
	patientSupporterLinkDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	patients?: FieldPolicy<any> | FieldReadFunction<any>,
	placeAutocomplete?: FieldPolicy<any> | FieldReadFunction<any>,
	placeDetails?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceRatings?: FieldPolicy<any> | FieldReadFunction<any>,
	practices?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariantAssignmentsForTrial?: FieldPolicy<any> | FieldReadFunction<any>,
	products?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetCollectionByID?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetCollections?: FieldPolicy<any> | FieldReadFunction<any>,
	relaxDiaryConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	relaxDiaryEntryCounts?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionByID?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionGroupByID?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDiaryEntryPracticeByDate?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDiaryEntryPracticeByID?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntryPracticeByID?: FieldPolicy<any> | FieldReadFunction<any>,
	treatmentV2?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	userByID?: FieldPolicy<any> | FieldReadFunction<any>,
	users?: FieldPolicy<any> | FieldReadFunction<any>,
	variantByID?: FieldPolicy<any> | FieldReadFunction<any>,
	ystOrganizationBySlug?: FieldPolicy<any> | FieldReadFunction<any>,
	ystOrganizations?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetKeySpecifier = ('ID' | 'description' | 'items' | 'legacyItems' | 'name' | 'previewOptions' | 'previewTime' | 'quizSetID' | QuizSetKeySpecifier)[];
export type QuizSetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	items?: FieldPolicy<any> | FieldReadFunction<any>,
	legacyItems?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	previewOptions?: FieldPolicy<any> | FieldReadFunction<any>,
	previewTime?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetCollectionKeySpecifier = ('name' | 'quizSetCollectionID' | 'session' | 'sets' | QuizSetCollectionKeySpecifier)[];
export type QuizSetCollectionFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetCollectionID?: FieldPolicy<any> | FieldReadFunction<any>,
	session?: FieldPolicy<any> | FieldReadFunction<any>,
	sets?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetCollectionCreatePayloadKeySpecifier = ('quizSetCollection' | QuizSetCollectionCreatePayloadKeySpecifier)[];
export type QuizSetCollectionCreatePayloadFieldPolicy = {
	quizSetCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetCollectionUpdatePayloadKeySpecifier = ('quizSetCollection' | QuizSetCollectionUpdatePayloadKeySpecifier)[];
export type QuizSetCollectionUpdatePayloadFieldPolicy = {
	quizSetCollection?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetCreatePayloadKeySpecifier = ('quizSet' | QuizSetCreatePayloadKeySpecifier)[];
export type QuizSetCreatePayloadFieldPolicy = {
	quizSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetDeletePayloadKeySpecifier = ('success' | QuizSetDeletePayloadKeySpecifier)[];
export type QuizSetDeletePayloadFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemKeySpecifier = ('quizSetItemID' | QuizSetItemKeySpecifier)[];
export type QuizSetItemFieldPolicy = {
	quizSetItemID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemChoiceKeySpecifier = ('afterAllFeedback' | 'correctFeedback' | 'incorrectFeedback' | 'options' | 'prompt' | 'quizSetItemID' | 'type' | QuizSetItemChoiceKeySpecifier)[];
export type QuizSetItemChoiceFieldPolicy = {
	afterAllFeedback?: FieldPolicy<any> | FieldReadFunction<any>,
	correctFeedback?: FieldPolicy<any> | FieldReadFunction<any>,
	incorrectFeedback?: FieldPolicy<any> | FieldReadFunction<any>,
	options?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetItemID?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemChoiceOptionKeySpecifier = ('correct' | 'feedback' | 'text' | 'value' | QuizSetItemChoiceOptionKeySpecifier)[];
export type QuizSetItemChoiceOptionFieldPolicy = {
	correct?: FieldPolicy<any> | FieldReadFunction<any>,
	feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemChoiceQuestionPropsKeySpecifier = ('label' | QuizSetItemChoiceQuestionPropsKeySpecifier)[];
export type QuizSetItemChoiceQuestionPropsFieldPolicy = {
	label?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemCreatePayloadKeySpecifier = ('legacyQuizSetItem' | 'quizSetItem' | QuizSetItemCreatePayloadKeySpecifier)[];
export type QuizSetItemCreatePayloadFieldPolicy = {
	legacyQuizSetItem?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetItem?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemDeletePayloadKeySpecifier = ('success' | QuizSetItemDeletePayloadKeySpecifier)[];
export type QuizSetItemDeletePayloadFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemQuestionDirectiveKeySpecifier = ('afterAll' | 'feedback' | 'prompt' | QuizSetItemQuestionDirectiveKeySpecifier)[];
export type QuizSetItemQuestionDirectiveFieldPolicy = {
	afterAll?: FieldPolicy<any> | FieldReadFunction<any>,
	feedback?: FieldPolicy<any> | FieldReadFunction<any>,
	prompt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemUpdateOrderPayloadKeySpecifier = ('success' | QuizSetItemUpdateOrderPayloadKeySpecifier)[];
export type QuizSetItemUpdateOrderPayloadFieldPolicy = {
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetItemVideoKeySpecifier = ('fileUpload' | 'quizSetItemID' | 'url' | QuizSetItemVideoKeySpecifier)[];
export type QuizSetItemVideoFieldPolicy = {
	fileUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetItemID?: FieldPolicy<any> | FieldReadFunction<any>,
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetPreviewOptionsKeySpecifier = ('fitMode' | 'height' | 'time' | QuizSetPreviewOptionsKeySpecifier)[];
export type QuizSetPreviewOptionsFieldPolicy = {
	fitMode?: FieldPolicy<any> | FieldReadFunction<any>,
	height?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type QuizSetUpdatePayloadKeySpecifier = ('quizSet' | QuizSetUpdatePayloadKeySpecifier)[];
export type QuizSetUpdatePayloadFieldPolicy = {
	quizSet?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RegistrarKeySpecifier = ('ID' | 'person' | RegistrarKeySpecifier)[];
export type RegistrarFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	person?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RelaxActionKeySpecifier = ('actionID' | 'actionValues' | RelaxActionKeySpecifier)[];
export type RelaxActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RelaxDiaryConfigKeySpecifier = ('ID' | 'breathingCircleExercise' | 'mindfulnessExercises' | 'mindfulnessTitle' | 'name' | RelaxDiaryConfigKeySpecifier)[];
export type RelaxDiaryConfigFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	breathingCircleExercise?: FieldPolicy<any> | FieldReadFunction<any>,
	mindfulnessExercises?: FieldPolicy<any> | FieldReadFunction<any>,
	mindfulnessTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RelaxDiaryEntryKeySpecifier = ('completion' | 'slug' | RelaxDiaryEntryKeySpecifier)[];
export type RelaxDiaryEntryFieldPolicy = {
	completion?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RelaxDiaryEntryPracticeKeySpecifier = ('practiceID' | 'practiceValues' | 'relaxDiaryEntry' | RelaxDiaryEntryPracticeKeySpecifier)[];
export type RelaxDiaryEntryPracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>,
	relaxDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RelaxDiaryWidgetKeySpecifier = ('ID' | 'breathingCircleExercise' | 'description' | 'iconName' | 'locked' | 'mindfulnessExercises' | 'mindfulnessTitle' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | RelaxDiaryWidgetKeySpecifier)[];
export type RelaxDiaryWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	breathingCircleExercise?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	mindfulnessExercises?: FieldPolicy<any> | FieldReadFunction<any>,
	mindfulnessTitle?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RelaxExerciseKeySpecifier = ('audioUrl' | 'illustrationUrl' | 'slug' | 'subtitleUrl' | 'title' | RelaxExerciseKeySpecifier)[];
export type RelaxExerciseFieldPolicy = {
	audioUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	illustrationUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitleUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RemoveHopeKitItemPayloadKeySpecifier = ('hopeKitItemID' | RemoveHopeKitItemPayloadKeySpecifier)[];
export type RemoveHopeKitItemPayloadFieldPolicy = {
	hopeKitItemID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ReplacePrimaryPractitionerResultKeySpecifier = ('careTeams' | 'success' | ReplacePrimaryPractitionerResultKeySpecifier)[];
export type ReplacePrimaryPractitionerResultFieldPolicy = {
	careTeams?: FieldPolicy<any> | FieldReadFunction<any>,
	success?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ResumableUploadAssetSessionKeySpecifier = ('asset' | 'resumableUploadAssetURI' | ResumableUploadAssetSessionKeySpecifier)[];
export type ResumableUploadAssetSessionFieldPolicy = {
	asset?: FieldPolicy<any> | FieldReadFunction<any>,
	resumableUploadAssetURI?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleKeySpecifier = ('ID' | 'activities' | 'activityDiaryWidget' | 'bingeEatingMyPlanWidget' | 'breathHoldingWidget' | 'checkinAvailability' | 'checkins' | 'cmsVariant' | 'composition' | 'copingCardsWidget' | 'eatingCommitmentComposition' | 'eatingCommitmentEntries' | 'eatingLogEntries' | 'eatingLogEntryByID' | 'eatingLogWidget' | 'eatingProgressEntries' | 'eatingProgressEntryByID' | 'eatingScheduleComposition' | 'hopeKitWidget' | 'hyperventilationWidget' | 'mentalHealthConcerns' | 'messages' | 'mostCompleted' | 'myPlanWidget' | 'nomination' | 'nominations' | 'onboardingAvailability' | 'onboardingAvailabilitySaved' | 'organization' | 'practitioners' | 'primaryPractitioner' | 'product' | 'productConfig' | 'productStatic' | 'progress' | 'relaxDiaryWidget' | 'roleLabel' | 'roleType' | 'sessions' | 'settings' | 'sleepDiaryWidget' | 'status' | 'streak' | 'streaks' | 'supportee' | 'supporters' | 'thoughtDiaryWidget' | 'user' | 'widgets' | 'wordPairingWidget' | RoleKeySpecifier)[];
export type RoleFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	activityDiaryWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	bingeEatingMyPlanWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	breathHoldingWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	checkinAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	checkins?: FieldPolicy<any> | FieldReadFunction<any>,
	cmsVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	composition?: FieldPolicy<any> | FieldReadFunction<any>,
	copingCardsWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingCommitmentComposition?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingCommitmentEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingLogEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingLogEntryByID?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingLogWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingProgressEntries?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingProgressEntryByID?: FieldPolicy<any> | FieldReadFunction<any>,
	eatingScheduleComposition?: FieldPolicy<any> | FieldReadFunction<any>,
	hopeKitWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	hyperventilationWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	mentalHealthConcerns?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	mostCompleted?: FieldPolicy<any> | FieldReadFunction<any>,
	myPlanWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	nomination?: FieldPolicy<any> | FieldReadFunction<any>,
	nominations?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingAvailabilitySaved?: FieldPolicy<any> | FieldReadFunction<any>,
	organization?: FieldPolicy<any> | FieldReadFunction<any>,
	practitioners?: FieldPolicy<any> | FieldReadFunction<any>,
	primaryPractitioner?: FieldPolicy<any> | FieldReadFunction<any>,
	product?: FieldPolicy<any> | FieldReadFunction<any>,
	productConfig?: FieldPolicy<any> | FieldReadFunction<any>,
	productStatic?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	relaxDiaryWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	roleLabel?: FieldPolicy<any> | FieldReadFunction<any>,
	roleType?: FieldPolicy<any> | FieldReadFunction<any>,
	sessions?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDiaryWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	streak?: FieldPolicy<any> | FieldReadFunction<any>,
	streaks?: FieldPolicy<any> | FieldReadFunction<any>,
	supportee?: FieldPolicy<any> | FieldReadFunction<any>,
	supporters?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryWidget?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>,
	widgets?: FieldPolicy<any> | FieldReadFunction<any>,
	wordPairingWidget?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleAvivaConfigKeySpecifier = ('caringContactsMedium' | 'crisisFramework' | 'lastCaringContactAt' | 'onboardingVariant' | 'productVersion' | RoleAvivaConfigKeySpecifier)[];
export type RoleAvivaConfigFieldPolicy = {
	caringContactsMedium?: FieldPolicy<any> | FieldReadFunction<any>,
	crisisFramework?: FieldPolicy<any> | FieldReadFunction<any>,
	lastCaringContactAt?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	productVersion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RolePtsdConfigKeySpecifier = ('dosageVersion' | RolePtsdConfigKeySpecifier)[];
export type RolePtsdConfigFieldPolicy = {
	dosageVersion?: FieldPolicy<any> | FieldReadFunction<any>
};
export type RoleSessionKeySpecifier = ('progress' | 'role' | 'session' | 'status' | 'unlockedAt' | RoleSessionKeySpecifier)[];
export type RoleSessionFieldPolicy = {
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	session?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionKeySpecifier = ('artifact' | 'description' | 'ordinal' | 'progress' | 'slug' | 'subtitle' | 'title' | SessionKeySpecifier)[];
export type SessionFieldPolicy = {
	artifact?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	ordinal?: FieldPolicy<any> | FieldReadFunction<any>,
	progress?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>,
	subtitle?: FieldPolicy<any> | FieldReadFunction<any>,
	title?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SessionContentForAppKeySpecifier = ('activities' | 'contentTypes' | 'exchange' | 'quizSetCollections' | SessionContentForAppKeySpecifier)[];
export type SessionContentForAppFieldPolicy = {
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	contentTypes?: FieldPolicy<any> | FieldReadFunction<any>,
	exchange?: FieldPolicy<any> | FieldReadFunction<any>,
	quizSetCollections?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SimpleErrorKeySpecifier = ('message' | SimpleErrorKeySpecifier)[];
export type SimpleErrorFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SleepDiaryEntryKeySpecifier = ('alcohol' | 'caffeine' | 'deviceInBed' | 'endTime' | 'exercise' | 'medicine' | 'napping' | 'sleepDelay' | 'startTime' | 'tobacco' | 'wakeupCount' | 'wakeupDuration' | SleepDiaryEntryKeySpecifier)[];
export type SleepDiaryEntryFieldPolicy = {
	alcohol?: FieldPolicy<any> | FieldReadFunction<any>,
	caffeine?: FieldPolicy<any> | FieldReadFunction<any>,
	deviceInBed?: FieldPolicy<any> | FieldReadFunction<any>,
	endTime?: FieldPolicy<any> | FieldReadFunction<any>,
	exercise?: FieldPolicy<any> | FieldReadFunction<any>,
	medicine?: FieldPolicy<any> | FieldReadFunction<any>,
	napping?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDelay?: FieldPolicy<any> | FieldReadFunction<any>,
	startTime?: FieldPolicy<any> | FieldReadFunction<any>,
	tobacco?: FieldPolicy<any> | FieldReadFunction<any>,
	wakeupCount?: FieldPolicy<any> | FieldReadFunction<any>,
	wakeupDuration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SleepDiaryEntryInfluencerKeySpecifier = ('count' | 'duration' | 'kinds' | 'occurred' | 'timesOfDay' | SleepDiaryEntryInfluencerKeySpecifier)[];
export type SleepDiaryEntryInfluencerFieldPolicy = {
	count?: FieldPolicy<any> | FieldReadFunction<any>,
	duration?: FieldPolicy<any> | FieldReadFunction<any>,
	kinds?: FieldPolicy<any> | FieldReadFunction<any>,
	occurred?: FieldPolicy<any> | FieldReadFunction<any>,
	timesOfDay?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SleepDiaryEntryMorningActionKeySpecifier = ('actionID' | 'actionValues' | 'sleepDiaryEntryPractice' | SleepDiaryEntryMorningActionKeySpecifier)[];
export type SleepDiaryEntryMorningActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SleepDiaryEntryNightActionKeySpecifier = ('actionID' | 'actionValues' | 'sleepDiaryEntryPractice' | SleepDiaryEntryNightActionKeySpecifier)[];
export type SleepDiaryEntryNightActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SleepDiaryEntryPracticeKeySpecifier = ('practiceID' | 'practiceValues' | 'sleepDiaryEntry' | SleepDiaryEntryPracticeKeySpecifier)[];
export type SleepDiaryEntryPracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>,
	sleepDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SleepDiaryWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | SleepDiaryWidgetKeySpecifier)[];
export type SleepDiaryWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StaticActionKeySpecifier = ('actionID' | 'actionValues' | StaticActionKeySpecifier)[];
export type StaticActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StressBreathingExerciseKeySpecifier = ('isComplete' | 'rounds' | StressBreathingExerciseKeySpecifier)[];
export type StressBreathingExerciseFieldPolicy = {
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	rounds?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StressBreathingRoundKeySpecifier = ('distressRating' | 'isComplete' | StressBreathingRoundKeySpecifier)[];
export type StressBreathingRoundFieldPolicy = {
	distressRating?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SubscriptionKeySpecifier = ('compositionByID' | 'patientPresence' | SubscriptionKeySpecifier)[];
export type SubscriptionFieldPolicy = {
	compositionByID?: FieldPolicy<any> | FieldReadFunction<any>,
	patientPresence?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupporteeKeySpecifier = ('ID' | 'claimed' | 'relation' | 'reviewed' | 'supportee' | SupporteeKeySpecifier)[];
export type SupporteeFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	claimed?: FieldPolicy<any> | FieldReadFunction<any>,
	relation?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewed?: FieldPolicy<any> | FieldReadFunction<any>,
	supportee?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupporterKeySpecifier = ('ID' | 'claimed' | 'relation' | 'reviewed' | 'supporter' | SupporterKeySpecifier)[];
export type SupporterFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	claimed?: FieldPolicy<any> | FieldReadFunction<any>,
	relation?: FieldPolicy<any> | FieldReadFunction<any>,
	reviewed?: FieldPolicy<any> | FieldReadFunction<any>,
	supporter?: FieldPolicy<any> | FieldReadFunction<any>
};
export type SupporterTokenKeySpecifier = ('url' | 'value' | SupporterTokenKeySpecifier)[];
export type SupporterTokenFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TextItemKeySpecifier = ('ID' | 'text' | TextItemKeySpecifier)[];
export type TextItemFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	text?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThoughtDiaryEntryKeySpecifier = ('behavior' | 'event' | 'evidenceAgainst' | 'evidenceFor' | 'feelingsAfter' | 'feelingsBefore' | 'thoughtAfter' | 'thoughtBefore' | ThoughtDiaryEntryKeySpecifier)[];
export type ThoughtDiaryEntryFieldPolicy = {
	behavior?: FieldPolicy<any> | FieldReadFunction<any>,
	event?: FieldPolicy<any> | FieldReadFunction<any>,
	evidenceAgainst?: FieldPolicy<any> | FieldReadFunction<any>,
	evidenceFor?: FieldPolicy<any> | FieldReadFunction<any>,
	feelingsAfter?: FieldPolicy<any> | FieldReadFunction<any>,
	feelingsBefore?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtAfter?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtBefore?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThoughtDiaryEntryPracticeKeySpecifier = ('practiceID' | 'practiceValues' | 'thoughtDiaryEntry' | ThoughtDiaryEntryPracticeKeySpecifier)[];
export type ThoughtDiaryEntryPracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntry?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThoughtDiaryEntrySpotActionKeySpecifier = ('actionID' | 'actionValues' | 'thoughtDiaryEntryPractice' | ThoughtDiaryEntrySpotActionKeySpecifier)[];
export type ThoughtDiaryEntrySpotActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThoughtDiaryEntrySwitchActionKeySpecifier = ('actionID' | 'actionValues' | 'thoughtDiaryEntryPractice' | ThoughtDiaryEntrySwitchActionKeySpecifier)[];
export type ThoughtDiaryEntrySwitchActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThoughtDiaryEntryTestActionKeySpecifier = ('actionID' | 'actionValues' | 'thoughtDiaryEntryPractice' | ThoughtDiaryEntryTestActionKeySpecifier)[];
export type ThoughtDiaryEntryTestActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>,
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ThoughtDiaryWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | ThoughtDiaryWidgetKeySpecifier)[];
export type ThoughtDiaryWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TokenKeySpecifier = ('expiresAt' | 'ouiUser' | 'value' | TokenKeySpecifier)[];
export type TokenFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ouiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type TrialPatientAssignmentKeySpecifier = ('createdAt' | 'email' | 'familyName' | 'givenName' | 'organizationName' | 'trialArmAssignment' | TrialPatientAssignmentKeySpecifier)[];
export type TrialPatientAssignmentFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	familyName?: FieldPolicy<any> | FieldReadFunction<any>,
	givenName?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationName?: FieldPolicy<any> | FieldReadFunction<any>,
	trialArmAssignment?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateActivityPracticePayloadKeySpecifier = ('activityPractice' | UpdateActivityPracticePayloadKeySpecifier)[];
export type UpdateActivityPracticePayloadFieldPolicy = {
	activityPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateHopeKitImagePayloadKeySpecifier = ('hopeKitImage' | UpdateHopeKitImagePayloadKeySpecifier)[];
export type UpdateHopeKitImagePayloadFieldPolicy = {
	hopeKitImage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateHopeKitQuotePayloadKeySpecifier = ('hopeKitQuote' | UpdateHopeKitQuotePayloadKeySpecifier)[];
export type UpdateHopeKitQuotePayloadFieldPolicy = {
	hopeKitQuote?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateHopeKitVideoPayloadKeySpecifier = ('hopeKitVideo' | UpdateHopeKitVideoPayloadKeySpecifier)[];
export type UpdateHopeKitVideoPayloadFieldPolicy = {
	hopeKitVideo?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdatePracticeResultKeySpecifier = ('practice' | UpdatePracticeResultKeySpecifier)[];
export type UpdatePracticeResultFieldPolicy = {
	practice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateRelaxDiaryEntryPracticePayloadKeySpecifier = ('relaxDiaryEntryPractice' | UpdateRelaxDiaryEntryPracticePayloadKeySpecifier)[];
export type UpdateRelaxDiaryEntryPracticePayloadFieldPolicy = {
	relaxDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateSleepDiaryEntryPracticePayloadKeySpecifier = ('sleepDiaryEntryPractice' | UpdateSleepDiaryEntryPracticePayloadKeySpecifier)[];
export type UpdateSleepDiaryEntryPracticePayloadFieldPolicy = {
	sleepDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UpdateThoughtDiaryEntryPracticePayloadKeySpecifier = ('thoughtDiaryEntryPractice' | UpdateThoughtDiaryEntryPracticePayloadKeySpecifier)[];
export type UpdateThoughtDiaryEntryPracticePayloadFieldPolicy = {
	thoughtDiaryEntryPractice?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UploadSessionKeySpecifier = ('url' | UploadSessionKeySpecifier)[];
export type UploadSessionFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsageIntervalKeySpecifier = ('sessionsCount' | 'sessionsDuration' | 'startAt' | UsageIntervalKeySpecifier)[];
export type UsageIntervalFieldPolicy = {
	sessionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionsDuration?: FieldPolicy<any> | FieldReadFunction<any>,
	startAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UsageSummaryKeySpecifier = ('sessionsCount' | 'sessionsDuration' | UsageSummaryKeySpecifier)[];
export type UsageSummaryFieldPolicy = {
	sessionsCount?: FieldPolicy<any> | FieldReadFunction<any>,
	sessionsDuration?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserKeySpecifier = ('ID' | 'addresses' | 'admin' | 'attributes' | 'birthDate' | 'createdAt' | 'deletedRoles' | 'email' | 'familyName' | 'genderIdentity' | 'givenName' | 'lastLogin' | 'locale' | 'militaryStatus' | 'passwordSetAt' | 'phone' | 'race' | 'role' | 'roles' | 'settings' | 'sexualOrientation' | 'timezone' | 'usage' | 'usageSummary' | 'username' | UserKeySpecifier)[];
export type UserFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	addresses?: FieldPolicy<any> | FieldReadFunction<any>,
	admin?: FieldPolicy<any> | FieldReadFunction<any>,
	attributes?: FieldPolicy<any> | FieldReadFunction<any>,
	birthDate?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	deletedRoles?: FieldPolicy<any> | FieldReadFunction<any>,
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	familyName?: FieldPolicy<any> | FieldReadFunction<any>,
	genderIdentity?: FieldPolicy<any> | FieldReadFunction<any>,
	givenName?: FieldPolicy<any> | FieldReadFunction<any>,
	lastLogin?: FieldPolicy<any> | FieldReadFunction<any>,
	locale?: FieldPolicy<any> | FieldReadFunction<any>,
	militaryStatus?: FieldPolicy<any> | FieldReadFunction<any>,
	passwordSetAt?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	race?: FieldPolicy<any> | FieldReadFunction<any>,
	role?: FieldPolicy<any> | FieldReadFunction<any>,
	roles?: FieldPolicy<any> | FieldReadFunction<any>,
	settings?: FieldPolicy<any> | FieldReadFunction<any>,
	sexualOrientation?: FieldPolicy<any> | FieldReadFunction<any>,
	timezone?: FieldPolicy<any> | FieldReadFunction<any>,
	usage?: FieldPolicy<any> | FieldReadFunction<any>,
	usageSummary?: FieldPolicy<any> | FieldReadFunction<any>,
	username?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAddressKeySpecifier = ('city' | 'country' | 'line1' | 'line2' | 'state' | 'zip' | UserAddressKeySpecifier)[];
export type UserAddressFieldPolicy = {
	city?: FieldPolicy<any> | FieldReadFunction<any>,
	country?: FieldPolicy<any> | FieldReadFunction<any>,
	line1?: FieldPolicy<any> | FieldReadFunction<any>,
	line2?: FieldPolicy<any> | FieldReadFunction<any>,
	state?: FieldPolicy<any> | FieldReadFunction<any>,
	zip?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserAttributesKeySpecifier = ('admin' | 'testUser' | 'trialAuditor' | UserAttributesKeySpecifier)[];
export type UserAttributesFieldPolicy = {
	admin?: FieldPolicy<any> | FieldReadFunction<any>,
	testUser?: FieldPolicy<any> | FieldReadFunction<any>,
	trialAuditor?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDemoKeySpecifier = ('DOB' | 'gender' | 'isVeteran' | 'race' | 'sexuality' | UserDemoKeySpecifier)[];
export type UserDemoFieldPolicy = {
	DOB?: FieldPolicy<any> | FieldReadFunction<any>,
	gender?: FieldPolicy<any> | FieldReadFunction<any>,
	isVeteran?: FieldPolicy<any> | FieldReadFunction<any>,
	race?: FieldPolicy<any> | FieldReadFunction<any>,
	sexuality?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserDisabledErrorKeySpecifier = ('message' | UserDisabledErrorKeySpecifier)[];
export type UserDisabledErrorFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserEmailKeySpecifier = ('createdAt' | 'description' | 'thirdPartyServiceID' | 'userEmailID' | UserEmailKeySpecifier)[];
export type UserEmailFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	thirdPartyServiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	userEmailID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserNameKeySpecifier = ('first' | 'last' | 'pfx' | 'preferred' | 'sfx' | UserNameKeySpecifier)[];
export type UserNameFieldPolicy = {
	first?: FieldPolicy<any> | FieldReadFunction<any>,
	last?: FieldPolicy<any> | FieldReadFunction<any>,
	pfx?: FieldPolicy<any> | FieldReadFunction<any>,
	preferred?: FieldPolicy<any> | FieldReadFunction<any>,
	sfx?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSessionKeySpecifier = ('currentOuiUser' | 'token' | 'user' | UserSessionKeySpecifier)[];
export type UserSessionFieldPolicy = {
	currentOuiUser?: FieldPolicy<any> | FieldReadFunction<any>,
	token?: FieldPolicy<any> | FieldReadFunction<any>,
	user?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSessionTokenKeySpecifier = ('expiresAt' | 'value' | UserSessionTokenKeySpecifier)[];
export type UserSessionTokenFieldPolicy = {
	expiresAt?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>
};
export type UserSettingsKeySpecifier = ('emailPreferred' | 'phonePreferred' | UserSettingsKeySpecifier)[];
export type UserSettingsFieldPolicy = {
	emailPreferred?: FieldPolicy<any> | FieldReadFunction<any>,
	phonePreferred?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidationErrorKeySpecifier = ('fieldErrors' | 'message' | ValidationErrorKeySpecifier)[];
export type ValidationErrorFieldPolicy = {
	fieldErrors?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>
};
export type ValidationFieldErrorKeySpecifier = ('message' | 'path' | ValidationFieldErrorKeySpecifier)[];
export type ValidationFieldErrorFieldPolicy = {
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	path?: FieldPolicy<any> | FieldReadFunction<any>
};
export type VideoKeySpecifier = ('ID' | 'fileUpload' | 'playbackUrl' | VideoKeySpecifier)[];
export type VideoFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	fileUpload?: FieldPolicy<any> | FieldReadFunction<any>,
	playbackUrl?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | WidgetKeySpecifier)[];
export type WidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WordPairingKeySpecifier = ('correctAnswersIncreased' | 'isComplete' | 'numRounds' | 'rounds' | 'timeToCompleteDecreased' | WordPairingKeySpecifier)[];
export type WordPairingFieldPolicy = {
	correctAnswersIncreased?: FieldPolicy<any> | FieldReadFunction<any>,
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	numRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	rounds?: FieldPolicy<any> | FieldReadFunction<any>,
	timeToCompleteDecreased?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WordPairingActionKeySpecifier = ('actionID' | 'actionValues' | WordPairingActionKeySpecifier)[];
export type WordPairingActionFieldPolicy = {
	actionID?: FieldPolicy<any> | FieldReadFunction<any>,
	actionValues?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WordPairingLevelKeySpecifier = ('badgeUrl' | 'level' | 'name' | 'nextLevelProgress' | 'nextLevelProgressMessage' | WordPairingLevelKeySpecifier)[];
export type WordPairingLevelFieldPolicy = {
	badgeUrl?: FieldPolicy<any> | FieldReadFunction<any>,
	level?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	nextLevelProgress?: FieldPolicy<any> | FieldReadFunction<any>,
	nextLevelProgressMessage?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WordPairingPracticeKeySpecifier = ('practiceID' | 'practiceValues' | 'wordPairing' | WordPairingPracticeKeySpecifier)[];
export type WordPairingPracticeFieldPolicy = {
	practiceID?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceValues?: FieldPolicy<any> | FieldReadFunction<any>,
	wordPairing?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WordPairingRoundKeySpecifier = ('isComplete' | 'numAnswers' | 'numCorrectAnswers' | 'numQuestions' | 'time' | WordPairingRoundKeySpecifier)[];
export type WordPairingRoundFieldPolicy = {
	isComplete?: FieldPolicy<any> | FieldReadFunction<any>,
	numAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	numCorrectAnswers?: FieldPolicy<any> | FieldReadFunction<any>,
	numQuestions?: FieldPolicy<any> | FieldReadFunction<any>,
	time?: FieldPolicy<any> | FieldReadFunction<any>
};
export type WordPairingWidgetKeySpecifier = ('ID' | 'description' | 'iconName' | 'locked' | 'name' | 'numQuestionsPerRound' | 'numRounds' | 'practiceCount' | 'practiceTileColor' | 'practiceTileDeeplink' | 'unlockSession' | 'wordPairingByID' | 'wordPairingLevel' | 'wordPairings' | WordPairingWidgetKeySpecifier)[];
export type WordPairingWidgetFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	description?: FieldPolicy<any> | FieldReadFunction<any>,
	iconName?: FieldPolicy<any> | FieldReadFunction<any>,
	locked?: FieldPolicy<any> | FieldReadFunction<any>,
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	numQuestionsPerRound?: FieldPolicy<any> | FieldReadFunction<any>,
	numRounds?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceCount?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileColor?: FieldPolicy<any> | FieldReadFunction<any>,
	practiceTileDeeplink?: FieldPolicy<any> | FieldReadFunction<any>,
	unlockSession?: FieldPolicy<any> | FieldReadFunction<any>,
	wordPairingByID?: FieldPolicy<any> | FieldReadFunction<any>,
	wordPairingLevel?: FieldPolicy<any> | FieldReadFunction<any>,
	wordPairings?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstGuardianProfileKeySpecifier = ('ID' | 'mentalHealthConcerns' | 'nominations' | 'patient' | 'productVariant' | YstGuardianProfileKeySpecifier)[];
export type YstGuardianProfileFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	mentalHealthConcerns?: FieldPolicy<any> | FieldReadFunction<any>,
	nominations?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstInviteKeySpecifier = ('url' | YstInviteKeySpecifier)[];
export type YstInviteFieldPolicy = {
	url?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstNominationKeySpecifier = ('email' | 'familyName' | 'givenName' | 'hasBeenInvited' | 'isNominating' | 'phone' | 'relation' | 'status' | 'ystNominationID' | YstNominationKeySpecifier)[];
export type YstNominationFieldPolicy = {
	email?: FieldPolicy<any> | FieldReadFunction<any>,
	familyName?: FieldPolicy<any> | FieldReadFunction<any>,
	givenName?: FieldPolicy<any> | FieldReadFunction<any>,
	hasBeenInvited?: FieldPolicy<any> | FieldReadFunction<any>,
	isNominating?: FieldPolicy<any> | FieldReadFunction<any>,
	phone?: FieldPolicy<any> | FieldReadFunction<any>,
	relation?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	ystNominationID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstNominationStatusKeySpecifier = ('reason' | 'status' | 'updatedAt' | YstNominationStatusKeySpecifier)[];
export type YstNominationStatusFieldPolicy = {
	reason?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	updatedAt?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstOrganizationKeySpecifier = ('name' | 'organizationID' | 'slug' | YstOrganizationKeySpecifier)[];
export type YstOrganizationFieldPolicy = {
	name?: FieldPolicy<any> | FieldReadFunction<any>,
	organizationID?: FieldPolicy<any> | FieldReadFunction<any>,
	slug?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstPatientMessageKeySpecifier = ('channel' | 'createdAt' | 'recipient' | 'type' | 'ystPatientMessageID' | YstPatientMessageKeySpecifier)[];
export type YstPatientMessageFieldPolicy = {
	channel?: FieldPolicy<any> | FieldReadFunction<any>,
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	recipient?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	ystPatientMessageID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstPatientMessagePreviewKeySpecifier = ('body' | 'message' | 'subject' | YstPatientMessagePreviewKeySpecifier)[];
export type YstPatientMessagePreviewFieldPolicy = {
	body?: FieldPolicy<any> | FieldReadFunction<any>,
	message?: FieldPolicy<any> | FieldReadFunction<any>,
	subject?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstProfileKeySpecifier = ('ID' | 'patient' | 'productVariant' | YstProfileKeySpecifier)[];
export type YstProfileFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstSupportProfileKeySpecifier = ('ID' | 'activities' | 'checkinAvailability' | 'checkins' | 'mentalHealthConcerns' | 'nomination' | 'onboardingAvailability' | 'onboardingAvailabilitySaved' | 'patient' | 'productVariant' | YstSupportProfileKeySpecifier)[];
export type YstSupportProfileFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	activities?: FieldPolicy<any> | FieldReadFunction<any>,
	checkinAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	checkins?: FieldPolicy<any> | FieldReadFunction<any>,
	mentalHealthConcerns?: FieldPolicy<any> | FieldReadFunction<any>,
	nomination?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingAvailability?: FieldPolicy<any> | FieldReadFunction<any>,
	onboardingAvailabilitySaved?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstSupporterCheckinKeySpecifier = ('ratedAt' | 'rating' | 'scheduledAt' | 'ystSupporterCheckinID' | YstSupporterCheckinKeySpecifier)[];
export type YstSupporterCheckinFieldPolicy = {
	ratedAt?: FieldPolicy<any> | FieldReadFunction<any>,
	rating?: FieldPolicy<any> | FieldReadFunction<any>,
	scheduledAt?: FieldPolicy<any> | FieldReadFunction<any>,
	ystSupporterCheckinID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstSupporterEventKeySpecifier = ('createdAt' | 'status' | 'type' | 'value' | 'ystSupporterEventID' | YstSupporterEventKeySpecifier)[];
export type YstSupporterEventFieldPolicy = {
	createdAt?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>,
	type?: FieldPolicy<any> | FieldReadFunction<any>,
	value?: FieldPolicy<any> | FieldReadFunction<any>,
	ystSupporterEventID?: FieldPolicy<any> | FieldReadFunction<any>
};
export type YstYouthProfileKeySpecifier = ('ID' | 'mentalHealthConcerns' | 'messages' | 'nominations' | 'patient' | 'productVariant' | 'status' | YstYouthProfileKeySpecifier)[];
export type YstYouthProfileFieldPolicy = {
	ID?: FieldPolicy<any> | FieldReadFunction<any>,
	mentalHealthConcerns?: FieldPolicy<any> | FieldReadFunction<any>,
	messages?: FieldPolicy<any> | FieldReadFunction<any>,
	nominations?: FieldPolicy<any> | FieldReadFunction<any>,
	patient?: FieldPolicy<any> | FieldReadFunction<any>,
	productVariant?: FieldPolicy<any> | FieldReadFunction<any>,
	status?: FieldPolicy<any> | FieldReadFunction<any>
};
export type StrictTypedTypePolicies = {
	AccessLog?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AccessLogKeySpecifier | (() => undefined | AccessLogKeySpecifier),
		fields?: AccessLogFieldPolicy,
	},
	Action?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActionKeySpecifier | (() => undefined | ActionKeySpecifier),
		fields?: ActionFieldPolicy,
	},
	ActionCount?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActionCountKeySpecifier | (() => undefined | ActionCountKeySpecifier),
		fields?: ActionCountFieldPolicy,
	},
	ActionProgress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActionProgressKeySpecifier | (() => undefined | ActionProgressKeySpecifier),
		fields?: ActionProgressFieldPolicy,
	},
	ActionTodos?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActionTodosKeySpecifier | (() => undefined | ActionTodosKeySpecifier),
		fields?: ActionTodosFieldPolicy,
	},
	ActionValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActionValuesKeySpecifier | (() => undefined | ActionValuesKeySpecifier),
		fields?: ActionValuesFieldPolicy,
	},
	Activity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityKeySpecifier | (() => undefined | ActivityKeySpecifier),
		fields?: ActivityFieldPolicy,
	},
	ActivityAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityAddActionKeySpecifier | (() => undefined | ActivityAddActionKeySpecifier),
		fields?: ActivityAddActionFieldPolicy,
	},
	ActivityDiaryWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityDiaryWidgetKeySpecifier | (() => undefined | ActivityDiaryWidgetKeySpecifier),
		fields?: ActivityDiaryWidgetFieldPolicy,
	},
	ActivityPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityPracticeKeySpecifier | (() => undefined | ActivityPracticeKeySpecifier),
		fields?: ActivityPracticeFieldPolicy,
	},
	ActivityRateAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ActivityRateActionKeySpecifier | (() => undefined | ActivityRateActionKeySpecifier),
		fields?: ActivityRateActionFieldPolicy,
	},
	AddActionPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddActionPayloadKeySpecifier | (() => undefined | AddActionPayloadKeySpecifier),
		fields?: AddActionPayloadFieldPolicy,
	},
	AddActivityPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddActivityPracticePayloadKeySpecifier | (() => undefined | AddActivityPracticePayloadKeySpecifier),
		fields?: AddActivityPracticePayloadFieldPolicy,
	},
	AddHopeKitImagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddHopeKitImagePayloadKeySpecifier | (() => undefined | AddHopeKitImagePayloadKeySpecifier),
		fields?: AddHopeKitImagePayloadFieldPolicy,
	},
	AddHopeKitQuotePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddHopeKitQuotePayloadKeySpecifier | (() => undefined | AddHopeKitQuotePayloadKeySpecifier),
		fields?: AddHopeKitQuotePayloadFieldPolicy,
	},
	AddHopeKitVideoPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddHopeKitVideoPayloadKeySpecifier | (() => undefined | AddHopeKitVideoPayloadKeySpecifier),
		fields?: AddHopeKitVideoPayloadFieldPolicy,
	},
	AddRelaxDiaryEntryPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddRelaxDiaryEntryPracticePayloadKeySpecifier | (() => undefined | AddRelaxDiaryEntryPracticePayloadKeySpecifier),
		fields?: AddRelaxDiaryEntryPracticePayloadFieldPolicy,
	},
	AddSleepDiaryEntryPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddSleepDiaryEntryPracticePayloadKeySpecifier | (() => undefined | AddSleepDiaryEntryPracticePayloadKeySpecifier),
		fields?: AddSleepDiaryEntryPracticePayloadFieldPolicy,
	},
	AddThoughtDiaryEntryPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddThoughtDiaryEntryPracticePayloadKeySpecifier | (() => undefined | AddThoughtDiaryEntryPracticePayloadKeySpecifier),
		fields?: AddThoughtDiaryEntryPracticePayloadFieldPolicy,
	},
	Address?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AddressKeySpecifier | (() => undefined | AddressKeySpecifier),
		fields?: AddressFieldPolicy,
	},
	AppActivity?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppActivityKeySpecifier | (() => undefined | AppActivityKeySpecifier),
		fields?: AppActivityFieldPolicy,
	},
	AppVersion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AppVersionKeySpecifier | (() => undefined | AppVersionKeySpecifier),
		fields?: AppVersionFieldPolicy,
	},
	Artifact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ArtifactKeySpecifier | (() => undefined | ArtifactKeySpecifier),
		fields?: ArtifactFieldPolicy,
	},
	Asset?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AssetKeySpecifier | (() => undefined | AssetKeySpecifier),
		fields?: AssetFieldPolicy,
	},
	AvivaProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | AvivaProfileKeySpecifier | (() => undefined | AvivaProfileKeySpecifier),
		fields?: AvivaProfileFieldPolicy,
	},
	BaseError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BaseErrorKeySpecifier | (() => undefined | BaseErrorKeySpecifier),
		fields?: BaseErrorFieldPolicy,
	},
	BingeEatingMyPlanWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BingeEatingMyPlanWidgetKeySpecifier | (() => undefined | BingeEatingMyPlanWidgetKeySpecifier),
		fields?: BingeEatingMyPlanWidgetFieldPolicy,
	},
	BotHistory?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BotHistoryKeySpecifier | (() => undefined | BotHistoryKeySpecifier),
		fields?: BotHistoryFieldPolicy,
	},
	BotState?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BotStateKeySpecifier | (() => undefined | BotStateKeySpecifier),
		fields?: BotStateFieldPolicy,
	},
	BreathHoldingAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreathHoldingActionKeySpecifier | (() => undefined | BreathHoldingActionKeySpecifier),
		fields?: BreathHoldingActionFieldPolicy,
	},
	BreathHoldingPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreathHoldingPracticeKeySpecifier | (() => undefined | BreathHoldingPracticeKeySpecifier),
		fields?: BreathHoldingPracticeFieldPolicy,
	},
	BreathHoldingWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | BreathHoldingWidgetKeySpecifier | (() => undefined | BreathHoldingWidgetKeySpecifier),
		fields?: BreathHoldingWidgetFieldPolicy,
	},
	CMSApp?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CMSAppKeySpecifier | (() => undefined | CMSAppKeySpecifier),
		fields?: CMSAppFieldPolicy,
	},
	CMSExchange?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CMSExchangeKeySpecifier | (() => undefined | CMSExchangeKeySpecifier),
		fields?: CMSExchangeFieldPolicy,
	},
	CMSSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CMSSessionKeySpecifier | (() => undefined | CMSSessionKeySpecifier),
		fields?: CMSSessionFieldPolicy,
	},
	CMSSessionGroup?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CMSSessionGroupKeySpecifier | (() => undefined | CMSSessionGroupKeySpecifier),
		fields?: CMSSessionGroupFieldPolicy,
	},
	CMSVariant?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CMSVariantKeySpecifier | (() => undefined | CMSVariantKeySpecifier),
		fields?: CMSVariantFieldPolicy,
	},
	CareTeam?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CareTeamKeySpecifier | (() => undefined | CareTeamKeySpecifier),
		fields?: CareTeamFieldPolicy,
	},
	ChangeBiteRoleSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ChangeBiteRoleSettingsKeySpecifier | (() => undefined | ChangeBiteRoleSettingsKeySpecifier),
		fields?: ChangeBiteRoleSettingsFieldPolicy,
	},
	CompletedPatientQuizSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompletedPatientQuizSetKeySpecifier | (() => undefined | CompletedPatientQuizSetKeySpecifier),
		fields?: CompletedPatientQuizSetFieldPolicy,
	},
	CompletedPatientQuizSets?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompletedPatientQuizSetsKeySpecifier | (() => undefined | CompletedPatientQuizSetsKeySpecifier),
		fields?: CompletedPatientQuizSetsFieldPolicy,
	},
	Composition?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompositionKeySpecifier | (() => undefined | CompositionKeySpecifier),
		fields?: CompositionFieldPolicy,
	},
	CompositionSection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CompositionSectionKeySpecifier | (() => undefined | CompositionSectionKeySpecifier),
		fields?: CompositionSectionFieldPolicy,
	},
	ContactPoint?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ContactPointKeySpecifier | (() => undefined | ContactPointKeySpecifier),
		fields?: ContactPointFieldPolicy,
	},
	CopingCardAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopingCardAddActionKeySpecifier | (() => undefined | CopingCardAddActionKeySpecifier),
		fields?: CopingCardAddActionFieldPolicy,
	},
	CopingCardReviewAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopingCardReviewActionKeySpecifier | (() => undefined | CopingCardReviewActionKeySpecifier),
		fields?: CopingCardReviewActionFieldPolicy,
	},
	CopingCardsWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CopingCardsWidgetKeySpecifier | (() => undefined | CopingCardsWidgetKeySpecifier),
		fields?: CopingCardsWidgetFieldPolicy,
	},
	CreateTestScenarioResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CreateTestScenarioResultKeySpecifier | (() => undefined | CreateTestScenarioResultKeySpecifier),
		fields?: CreateTestScenarioResultFieldPolicy,
	},
	CurrentOuiUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | CurrentOuiUserKeySpecifier | (() => undefined | CurrentOuiUserKeySpecifier),
		fields?: CurrentOuiUserFieldPolicy,
	},
	DeletedRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeletedRoleKeySpecifier | (() => undefined | DeletedRoleKeySpecifier),
		fields?: DeletedRoleFieldPolicy,
	},
	Device?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | DeviceKeySpecifier | (() => undefined | DeviceKeySpecifier),
		fields?: DeviceFieldPolicy,
	},
	EatingCheckin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingCheckinKeySpecifier | (() => undefined | EatingCheckinKeySpecifier),
		fields?: EatingCheckinFieldPolicy,
	},
	EatingCheckinPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingCheckinPracticeKeySpecifier | (() => undefined | EatingCheckinPracticeKeySpecifier),
		fields?: EatingCheckinPracticeFieldPolicy,
	},
	EatingCommitmentEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingCommitmentEntryKeySpecifier | (() => undefined | EatingCommitmentEntryKeySpecifier),
		fields?: EatingCommitmentEntryFieldPolicy,
	},
	EatingCommitmentEntryPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingCommitmentEntryPracticeKeySpecifier | (() => undefined | EatingCommitmentEntryPracticeKeySpecifier),
		fields?: EatingCommitmentEntryPracticeFieldPolicy,
	},
	EatingLogAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingLogAddActionKeySpecifier | (() => undefined | EatingLogAddActionKeySpecifier),
		fields?: EatingLogAddActionFieldPolicy,
	},
	EatingLogEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingLogEntryKeySpecifier | (() => undefined | EatingLogEntryKeySpecifier),
		fields?: EatingLogEntryFieldPolicy,
	},
	EatingLogEntryPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingLogEntryPracticeKeySpecifier | (() => undefined | EatingLogEntryPracticeKeySpecifier),
		fields?: EatingLogEntryPracticeFieldPolicy,
	},
	EatingLogWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingLogWidgetKeySpecifier | (() => undefined | EatingLogWidgetKeySpecifier),
		fields?: EatingLogWidgetFieldPolicy,
	},
	EatingProgressEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingProgressEntryKeySpecifier | (() => undefined | EatingProgressEntryKeySpecifier),
		fields?: EatingProgressEntryFieldPolicy,
	},
	EatingProgressEntryPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | EatingProgressEntryPracticeKeySpecifier | (() => undefined | EatingProgressEntryPracticeKeySpecifier),
		fields?: EatingProgressEntryPracticeFieldPolicy,
	},
	ExchangePatchResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExchangePatchResultKeySpecifier | (() => undefined | ExchangePatchResultKeySpecifier),
		fields?: ExchangePatchResultFieldPolicy,
	},
	ExchangePreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ExchangePreviewKeySpecifier | (() => undefined | ExchangePreviewKeySpecifier),
		fields?: ExchangePreviewFieldPolicy,
	},
	FileUpload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileUploadKeySpecifier | (() => undefined | FileUploadKeySpecifier),
		fields?: FileUploadFieldPolicy,
	},
	FileUploadAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileUploadActionKeySpecifier | (() => undefined | FileUploadActionKeySpecifier),
		fields?: FileUploadActionFieldPolicy,
	},
	FileUploadSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | FileUploadSessionKeySpecifier | (() => undefined | FileUploadSessionKeySpecifier),
		fields?: FileUploadSessionFieldPolicy,
	},
	HopeKitAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HopeKitAddActionKeySpecifier | (() => undefined | HopeKitAddActionKeySpecifier),
		fields?: HopeKitAddActionFieldPolicy,
	},
	HopeKitImage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HopeKitImageKeySpecifier | (() => undefined | HopeKitImageKeySpecifier),
		fields?: HopeKitImageFieldPolicy,
	},
	HopeKitQuote?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HopeKitQuoteKeySpecifier | (() => undefined | HopeKitQuoteKeySpecifier),
		fields?: HopeKitQuoteFieldPolicy,
	},
	HopeKitReviewAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HopeKitReviewActionKeySpecifier | (() => undefined | HopeKitReviewActionKeySpecifier),
		fields?: HopeKitReviewActionFieldPolicy,
	},
	HopeKitVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HopeKitVideoKeySpecifier | (() => undefined | HopeKitVideoKeySpecifier),
		fields?: HopeKitVideoFieldPolicy,
	},
	HopeKitWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HopeKitWidgetKeySpecifier | (() => undefined | HopeKitWidgetKeySpecifier),
		fields?: HopeKitWidgetFieldPolicy,
	},
	HyperventilationAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HyperventilationActionKeySpecifier | (() => undefined | HyperventilationActionKeySpecifier),
		fields?: HyperventilationActionFieldPolicy,
	},
	HyperventilationPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HyperventilationPracticeKeySpecifier | (() => undefined | HyperventilationPracticeKeySpecifier),
		fields?: HyperventilationPracticeFieldPolicy,
	},
	HyperventilationWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | HyperventilationWidgetKeySpecifier | (() => undefined | HyperventilationWidgetKeySpecifier),
		fields?: HyperventilationWidgetFieldPolicy,
	},
	IPatientProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | IPatientProfileKeySpecifier | (() => undefined | IPatientProfileKeySpecifier),
		fields?: IPatientProfileFieldPolicy,
	},
	InvalidPasswordError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | InvalidPasswordErrorKeySpecifier | (() => undefined | InvalidPasswordErrorKeySpecifier),
		fields?: InvalidPasswordErrorFieldPolicy,
	},
	Job?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | JobKeySpecifier | (() => undefined | JobKeySpecifier),
		fields?: JobFieldPolicy,
	},
	KVResponse?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | KVResponseKeySpecifier | (() => undefined | KVResponseKeySpecifier),
		fields?: KVResponseFieldPolicy,
	},
	LatLng?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LatLngKeySpecifier | (() => undefined | LatLngKeySpecifier),
		fields?: LatLngFieldPolicy,
	},
	LegacyQuizSetItemMultipleChoiceQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyQuizSetItemMultipleChoiceQuestionKeySpecifier | (() => undefined | LegacyQuizSetItemMultipleChoiceQuestionKeySpecifier),
		fields?: LegacyQuizSetItemMultipleChoiceQuestionFieldPolicy,
	},
	LegacyQuizSetItemSingleChoiceQuestion?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyQuizSetItemSingleChoiceQuestionKeySpecifier | (() => undefined | LegacyQuizSetItemSingleChoiceQuestionKeySpecifier),
		fields?: LegacyQuizSetItemSingleChoiceQuestionFieldPolicy,
	},
	LegacyQuizSetItemVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyQuizSetItemVideoKeySpecifier | (() => undefined | LegacyQuizSetItemVideoKeySpecifier),
		fields?: LegacyQuizSetItemVideoFieldPolicy,
	},
	LegacyQuizSetItemVideoProps?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyQuizSetItemVideoPropsKeySpecifier | (() => undefined | LegacyQuizSetItemVideoPropsKeySpecifier),
		fields?: LegacyQuizSetItemVideoPropsFieldPolicy,
	},
	LegacyUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LegacyUserKeySpecifier | (() => undefined | LegacyUserKeySpecifier),
		fields?: LegacyUserFieldPolicy,
	},
	LessonLearned?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | LessonLearnedKeySpecifier | (() => undefined | LessonLearnedKeySpecifier),
		fields?: LessonLearnedFieldPolicy,
	},
	MostCompleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MostCompletedKeySpecifier | (() => undefined | MostCompletedKeySpecifier),
		fields?: MostCompletedFieldPolicy,
	},
	Mutation?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationKeySpecifier | (() => undefined | MutationKeySpecifier),
		fields?: MutationFieldPolicy,
	},
	MutationNominateYstSupportersSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationNominateYstSupportersSuccessKeySpecifier | (() => undefined | MutationNominateYstSupportersSuccessKeySpecifier),
		fields?: MutationNominateYstSupportersSuccessFieldPolicy,
	},
	MutationResendYstPatientMessageSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationResendYstPatientMessageSuccessKeySpecifier | (() => undefined | MutationResendYstPatientMessageSuccessKeySpecifier),
		fields?: MutationResendYstPatientMessageSuccessFieldPolicy,
	},
	MutationUpdateFirstCheckinDateSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationUpdateFirstCheckinDateSuccessKeySpecifier | (() => undefined | MutationUpdateFirstCheckinDateSuccessKeySpecifier),
		fields?: MutationUpdateFirstCheckinDateSuccessFieldPolicy,
	},
	MutationUpdateOnboardingAvailabilitySuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationUpdateOnboardingAvailabilitySuccessKeySpecifier | (() => undefined | MutationUpdateOnboardingAvailabilitySuccessKeySpecifier),
		fields?: MutationUpdateOnboardingAvailabilitySuccessFieldPolicy,
	},
	MutationUpdateRecurringAvailabilitySuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationUpdateRecurringAvailabilitySuccessKeySpecifier | (() => undefined | MutationUpdateRecurringAvailabilitySuccessKeySpecifier),
		fields?: MutationUpdateRecurringAvailabilitySuccessFieldPolicy,
	},
	MutationUpdateYstMentalHealthConcernsSuccess?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MutationUpdateYstMentalHealthConcernsSuccessKeySpecifier | (() => undefined | MutationUpdateYstMentalHealthConcernsSuccessKeySpecifier),
		fields?: MutationUpdateYstMentalHealthConcernsSuccessFieldPolicy,
	},
	MyPlanReviewAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MyPlanReviewActionKeySpecifier | (() => undefined | MyPlanReviewActionKeySpecifier),
		fields?: MyPlanReviewActionFieldPolicy,
	},
	MyPlanWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | MyPlanWidgetKeySpecifier | (() => undefined | MyPlanWidgetKeySpecifier),
		fields?: MyPlanWidgetFieldPolicy,
	},
	Organization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationKeySpecifier | (() => undefined | OrganizationKeySpecifier),
		fields?: OrganizationFieldPolicy,
	},
	OrganizationAvivaConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationAvivaConfigKeySpecifier | (() => undefined | OrganizationAvivaConfigKeySpecifier),
		fields?: OrganizationAvivaConfigFieldPolicy,
	},
	OrganizationMember?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationMemberKeySpecifier | (() => undefined | OrganizationMemberKeySpecifier),
		fields?: OrganizationMemberFieldPolicy,
	},
	OrganizationMemberResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationMemberResultKeySpecifier | (() => undefined | OrganizationMemberResultKeySpecifier),
		fields?: OrganizationMemberResultFieldPolicy,
	},
	OrganizationProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationProductKeySpecifier | (() => undefined | OrganizationProductKeySpecifier),
		fields?: OrganizationProductFieldPolicy,
	},
	OrganizationStats?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationStatsKeySpecifier | (() => undefined | OrganizationStatsKeySpecifier),
		fields?: OrganizationStatsFieldPolicy,
	},
	OrganizationYstConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OrganizationYstConfigKeySpecifier | (() => undefined | OrganizationYstConfigKeySpecifier),
		fields?: OrganizationYstConfigFieldPolicy,
	},
	OuiAdmin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OuiAdminKeySpecifier | (() => undefined | OuiAdminKeySpecifier),
		fields?: OuiAdminFieldPolicy,
	},
	OuiProgress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OuiProgressKeySpecifier | (() => undefined | OuiProgressKeySpecifier),
		fields?: OuiProgressFieldPolicy,
	},
	OuiUser?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OuiUserKeySpecifier | (() => undefined | OuiUserKeySpecifier),
		fields?: OuiUserFieldPolicy,
	},
	OuiUserAttributes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OuiUserAttributesKeySpecifier | (() => undefined | OuiUserAttributesKeySpecifier),
		fields?: OuiUserAttributesFieldPolicy,
	},
	OuiUserProduct?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OuiUserProductKeySpecifier | (() => undefined | OuiUserProductKeySpecifier),
		fields?: OuiUserProductFieldPolicy,
	},
	OuiUserRole?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OuiUserRoleKeySpecifier | (() => undefined | OuiUserRoleKeySpecifier),
		fields?: OuiUserRoleFieldPolicy,
	},
	OutdatedBotStateError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | OutdatedBotStateErrorKeySpecifier | (() => undefined | OutdatedBotStateErrorKeySpecifier),
		fields?: OutdatedBotStateErrorFieldPolicy,
	},
	Patient?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientKeySpecifier | (() => undefined | PatientKeySpecifier),
		fields?: PatientFieldPolicy,
	},
	PatientCaringContact?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientCaringContactKeySpecifier | (() => undefined | PatientCaringContactKeySpecifier),
		fields?: PatientCaringContactFieldPolicy,
	},
	PatientNotification?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientNotificationKeySpecifier | (() => undefined | PatientNotificationKeySpecifier),
		fields?: PatientNotificationFieldPolicy,
	},
	PatientProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientProfileKeySpecifier | (() => undefined | PatientProfileKeySpecifier),
		fields?: PatientProfileFieldPolicy,
	},
	PatientQuizSetCompleted?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientQuizSetCompletedKeySpecifier | (() => undefined | PatientQuizSetCompletedKeySpecifier),
		fields?: PatientQuizSetCompletedFieldPolicy,
	},
	PatientSupportLinkDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientSupportLinkDetailsKeySpecifier | (() => undefined | PatientSupportLinkDetailsKeySpecifier),
		fields?: PatientSupportLinkDetailsFieldPolicy,
	},
	PatientSupporter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PatientSupporterKeySpecifier | (() => undefined | PatientSupporterKeySpecifier),
		fields?: PatientSupporterFieldPolicy,
	},
	PendingAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingActionKeySpecifier | (() => undefined | PendingActionKeySpecifier),
		fields?: PendingActionFieldPolicy,
	},
	PendingActivityAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingActivityAddActionKeySpecifier | (() => undefined | PendingActivityAddActionKeySpecifier),
		fields?: PendingActivityAddActionFieldPolicy,
	},
	PendingActivityRateAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingActivityRateActionKeySpecifier | (() => undefined | PendingActivityRateActionKeySpecifier),
		fields?: PendingActivityRateActionFieldPolicy,
	},
	PendingBreathHoldingAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingBreathHoldingActionKeySpecifier | (() => undefined | PendingBreathHoldingActionKeySpecifier),
		fields?: PendingBreathHoldingActionFieldPolicy,
	},
	PendingCopingCardAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingCopingCardAddActionKeySpecifier | (() => undefined | PendingCopingCardAddActionKeySpecifier),
		fields?: PendingCopingCardAddActionFieldPolicy,
	},
	PendingCopingCardReviewAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingCopingCardReviewActionKeySpecifier | (() => undefined | PendingCopingCardReviewActionKeySpecifier),
		fields?: PendingCopingCardReviewActionFieldPolicy,
	},
	PendingEatingLogAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingEatingLogAddActionKeySpecifier | (() => undefined | PendingEatingLogAddActionKeySpecifier),
		fields?: PendingEatingLogAddActionFieldPolicy,
	},
	PendingHopeKitAddAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingHopeKitAddActionKeySpecifier | (() => undefined | PendingHopeKitAddActionKeySpecifier),
		fields?: PendingHopeKitAddActionFieldPolicy,
	},
	PendingHopeKitReviewAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingHopeKitReviewActionKeySpecifier | (() => undefined | PendingHopeKitReviewActionKeySpecifier),
		fields?: PendingHopeKitReviewActionFieldPolicy,
	},
	PendingHyperventilationAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingHyperventilationActionKeySpecifier | (() => undefined | PendingHyperventilationActionKeySpecifier),
		fields?: PendingHyperventilationActionFieldPolicy,
	},
	PendingMyPlanReviewAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingMyPlanReviewActionKeySpecifier | (() => undefined | PendingMyPlanReviewActionKeySpecifier),
		fields?: PendingMyPlanReviewActionFieldPolicy,
	},
	PendingRelaxAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingRelaxActionKeySpecifier | (() => undefined | PendingRelaxActionKeySpecifier),
		fields?: PendingRelaxActionFieldPolicy,
	},
	PendingSleepDiaryEntryMorningAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingSleepDiaryEntryMorningActionKeySpecifier | (() => undefined | PendingSleepDiaryEntryMorningActionKeySpecifier),
		fields?: PendingSleepDiaryEntryMorningActionFieldPolicy,
	},
	PendingSleepDiaryEntryNightAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingSleepDiaryEntryNightActionKeySpecifier | (() => undefined | PendingSleepDiaryEntryNightActionKeySpecifier),
		fields?: PendingSleepDiaryEntryNightActionFieldPolicy,
	},
	PendingThoughtDiaryEntrySpotAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingThoughtDiaryEntrySpotActionKeySpecifier | (() => undefined | PendingThoughtDiaryEntrySpotActionKeySpecifier),
		fields?: PendingThoughtDiaryEntrySpotActionFieldPolicy,
	},
	PendingThoughtDiaryEntrySwitchAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingThoughtDiaryEntrySwitchActionKeySpecifier | (() => undefined | PendingThoughtDiaryEntrySwitchActionKeySpecifier),
		fields?: PendingThoughtDiaryEntrySwitchActionFieldPolicy,
	},
	PendingThoughtDiaryEntryTestAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingThoughtDiaryEntryTestActionKeySpecifier | (() => undefined | PendingThoughtDiaryEntryTestActionKeySpecifier),
		fields?: PendingThoughtDiaryEntryTestActionFieldPolicy,
	},
	PendingWordPairingAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PendingWordPairingActionKeySpecifier | (() => undefined | PendingWordPairingActionKeySpecifier),
		fields?: PendingWordPairingActionFieldPolicy,
	},
	Person?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PersonKeySpecifier | (() => undefined | PersonKeySpecifier),
		fields?: PersonFieldPolicy,
	},
	PlaceAutocomplete?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceAutocompleteKeySpecifier | (() => undefined | PlaceAutocompleteKeySpecifier),
		fields?: PlaceAutocompleteFieldPolicy,
	},
	PlaceDetails?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceDetailsKeySpecifier | (() => undefined | PlaceDetailsKeySpecifier),
		fields?: PlaceDetailsFieldPolicy,
	},
	PlaceGeometry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceGeometryKeySpecifier | (() => undefined | PlaceGeometryKeySpecifier),
		fields?: PlaceGeometryFieldPolicy,
	},
	PlaceStructuredFormatting?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PlaceStructuredFormattingKeySpecifier | (() => undefined | PlaceStructuredFormattingKeySpecifier),
		fields?: PlaceStructuredFormattingFieldPolicy,
	},
	Practice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PracticeKeySpecifier | (() => undefined | PracticeKeySpecifier),
		fields?: PracticeFieldPolicy,
	},
	PracticeRating?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PracticeRatingKeySpecifier | (() => undefined | PracticeRatingKeySpecifier),
		fields?: PracticeRatingFieldPolicy,
	},
	PracticeRatingInterval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PracticeRatingIntervalKeySpecifier | (() => undefined | PracticeRatingIntervalKeySpecifier),
		fields?: PracticeRatingIntervalFieldPolicy,
	},
	PracticeValues?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PracticeValuesKeySpecifier | (() => undefined | PracticeValuesKeySpecifier),
		fields?: PracticeValuesFieldPolicy,
	},
	Practitioner?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PractitionerKeySpecifier | (() => undefined | PractitionerKeySpecifier),
		fields?: PractitionerFieldPolicy,
	},
	Presence?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | PresenceKeySpecifier | (() => undefined | PresenceKeySpecifier),
		fields?: PresenceFieldPolicy,
	},
	Product?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductKeySpecifier | (() => undefined | ProductKeySpecifier),
		fields?: ProductFieldPolicy,
	},
	ProductRoleType?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ProductRoleTypeKeySpecifier | (() => undefined | ProductRoleTypeKeySpecifier),
		fields?: ProductRoleTypeFieldPolicy,
	},
	Query?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QueryKeySpecifier | (() => undefined | QueryKeySpecifier),
		fields?: QueryFieldPolicy,
	},
	QuizSet?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetKeySpecifier | (() => undefined | QuizSetKeySpecifier),
		fields?: QuizSetFieldPolicy,
	},
	QuizSetCollection?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetCollectionKeySpecifier | (() => undefined | QuizSetCollectionKeySpecifier),
		fields?: QuizSetCollectionFieldPolicy,
	},
	QuizSetCollectionCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetCollectionCreatePayloadKeySpecifier | (() => undefined | QuizSetCollectionCreatePayloadKeySpecifier),
		fields?: QuizSetCollectionCreatePayloadFieldPolicy,
	},
	QuizSetCollectionUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetCollectionUpdatePayloadKeySpecifier | (() => undefined | QuizSetCollectionUpdatePayloadKeySpecifier),
		fields?: QuizSetCollectionUpdatePayloadFieldPolicy,
	},
	QuizSetCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetCreatePayloadKeySpecifier | (() => undefined | QuizSetCreatePayloadKeySpecifier),
		fields?: QuizSetCreatePayloadFieldPolicy,
	},
	QuizSetDeletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetDeletePayloadKeySpecifier | (() => undefined | QuizSetDeletePayloadKeySpecifier),
		fields?: QuizSetDeletePayloadFieldPolicy,
	},
	QuizSetItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemKeySpecifier | (() => undefined | QuizSetItemKeySpecifier),
		fields?: QuizSetItemFieldPolicy,
	},
	QuizSetItemChoice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemChoiceKeySpecifier | (() => undefined | QuizSetItemChoiceKeySpecifier),
		fields?: QuizSetItemChoiceFieldPolicy,
	},
	QuizSetItemChoiceOption?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemChoiceOptionKeySpecifier | (() => undefined | QuizSetItemChoiceOptionKeySpecifier),
		fields?: QuizSetItemChoiceOptionFieldPolicy,
	},
	QuizSetItemChoiceQuestionProps?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemChoiceQuestionPropsKeySpecifier | (() => undefined | QuizSetItemChoiceQuestionPropsKeySpecifier),
		fields?: QuizSetItemChoiceQuestionPropsFieldPolicy,
	},
	QuizSetItemCreatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemCreatePayloadKeySpecifier | (() => undefined | QuizSetItemCreatePayloadKeySpecifier),
		fields?: QuizSetItemCreatePayloadFieldPolicy,
	},
	QuizSetItemDeletePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemDeletePayloadKeySpecifier | (() => undefined | QuizSetItemDeletePayloadKeySpecifier),
		fields?: QuizSetItemDeletePayloadFieldPolicy,
	},
	QuizSetItemQuestionDirective?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemQuestionDirectiveKeySpecifier | (() => undefined | QuizSetItemQuestionDirectiveKeySpecifier),
		fields?: QuizSetItemQuestionDirectiveFieldPolicy,
	},
	QuizSetItemUpdateOrderPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemUpdateOrderPayloadKeySpecifier | (() => undefined | QuizSetItemUpdateOrderPayloadKeySpecifier),
		fields?: QuizSetItemUpdateOrderPayloadFieldPolicy,
	},
	QuizSetItemVideo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetItemVideoKeySpecifier | (() => undefined | QuizSetItemVideoKeySpecifier),
		fields?: QuizSetItemVideoFieldPolicy,
	},
	QuizSetPreviewOptions?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetPreviewOptionsKeySpecifier | (() => undefined | QuizSetPreviewOptionsKeySpecifier),
		fields?: QuizSetPreviewOptionsFieldPolicy,
	},
	QuizSetUpdatePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | QuizSetUpdatePayloadKeySpecifier | (() => undefined | QuizSetUpdatePayloadKeySpecifier),
		fields?: QuizSetUpdatePayloadFieldPolicy,
	},
	Registrar?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RegistrarKeySpecifier | (() => undefined | RegistrarKeySpecifier),
		fields?: RegistrarFieldPolicy,
	},
	RelaxAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RelaxActionKeySpecifier | (() => undefined | RelaxActionKeySpecifier),
		fields?: RelaxActionFieldPolicy,
	},
	RelaxDiaryConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RelaxDiaryConfigKeySpecifier | (() => undefined | RelaxDiaryConfigKeySpecifier),
		fields?: RelaxDiaryConfigFieldPolicy,
	},
	RelaxDiaryEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RelaxDiaryEntryKeySpecifier | (() => undefined | RelaxDiaryEntryKeySpecifier),
		fields?: RelaxDiaryEntryFieldPolicy,
	},
	RelaxDiaryEntryPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RelaxDiaryEntryPracticeKeySpecifier | (() => undefined | RelaxDiaryEntryPracticeKeySpecifier),
		fields?: RelaxDiaryEntryPracticeFieldPolicy,
	},
	RelaxDiaryWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RelaxDiaryWidgetKeySpecifier | (() => undefined | RelaxDiaryWidgetKeySpecifier),
		fields?: RelaxDiaryWidgetFieldPolicy,
	},
	RelaxExercise?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RelaxExerciseKeySpecifier | (() => undefined | RelaxExerciseKeySpecifier),
		fields?: RelaxExerciseFieldPolicy,
	},
	RemoveHopeKitItemPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RemoveHopeKitItemPayloadKeySpecifier | (() => undefined | RemoveHopeKitItemPayloadKeySpecifier),
		fields?: RemoveHopeKitItemPayloadFieldPolicy,
	},
	ReplacePrimaryPractitionerResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ReplacePrimaryPractitionerResultKeySpecifier | (() => undefined | ReplacePrimaryPractitionerResultKeySpecifier),
		fields?: ReplacePrimaryPractitionerResultFieldPolicy,
	},
	ResumableUploadAssetSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ResumableUploadAssetSessionKeySpecifier | (() => undefined | ResumableUploadAssetSessionKeySpecifier),
		fields?: ResumableUploadAssetSessionFieldPolicy,
	},
	Role?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleKeySpecifier | (() => undefined | RoleKeySpecifier),
		fields?: RoleFieldPolicy,
	},
	RoleAvivaConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleAvivaConfigKeySpecifier | (() => undefined | RoleAvivaConfigKeySpecifier),
		fields?: RoleAvivaConfigFieldPolicy,
	},
	RolePtsdConfig?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RolePtsdConfigKeySpecifier | (() => undefined | RolePtsdConfigKeySpecifier),
		fields?: RolePtsdConfigFieldPolicy,
	},
	RoleSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | RoleSessionKeySpecifier | (() => undefined | RoleSessionKeySpecifier),
		fields?: RoleSessionFieldPolicy,
	},
	Session?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionKeySpecifier | (() => undefined | SessionKeySpecifier),
		fields?: SessionFieldPolicy,
	},
	SessionContentForApp?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SessionContentForAppKeySpecifier | (() => undefined | SessionContentForAppKeySpecifier),
		fields?: SessionContentForAppFieldPolicy,
	},
	SimpleError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SimpleErrorKeySpecifier | (() => undefined | SimpleErrorKeySpecifier),
		fields?: SimpleErrorFieldPolicy,
	},
	SleepDiaryEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SleepDiaryEntryKeySpecifier | (() => undefined | SleepDiaryEntryKeySpecifier),
		fields?: SleepDiaryEntryFieldPolicy,
	},
	SleepDiaryEntryInfluencer?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SleepDiaryEntryInfluencerKeySpecifier | (() => undefined | SleepDiaryEntryInfluencerKeySpecifier),
		fields?: SleepDiaryEntryInfluencerFieldPolicy,
	},
	SleepDiaryEntryMorningAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SleepDiaryEntryMorningActionKeySpecifier | (() => undefined | SleepDiaryEntryMorningActionKeySpecifier),
		fields?: SleepDiaryEntryMorningActionFieldPolicy,
	},
	SleepDiaryEntryNightAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SleepDiaryEntryNightActionKeySpecifier | (() => undefined | SleepDiaryEntryNightActionKeySpecifier),
		fields?: SleepDiaryEntryNightActionFieldPolicy,
	},
	SleepDiaryEntryPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SleepDiaryEntryPracticeKeySpecifier | (() => undefined | SleepDiaryEntryPracticeKeySpecifier),
		fields?: SleepDiaryEntryPracticeFieldPolicy,
	},
	SleepDiaryWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SleepDiaryWidgetKeySpecifier | (() => undefined | SleepDiaryWidgetKeySpecifier),
		fields?: SleepDiaryWidgetFieldPolicy,
	},
	StaticAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StaticActionKeySpecifier | (() => undefined | StaticActionKeySpecifier),
		fields?: StaticActionFieldPolicy,
	},
	StressBreathingExercise?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StressBreathingExerciseKeySpecifier | (() => undefined | StressBreathingExerciseKeySpecifier),
		fields?: StressBreathingExerciseFieldPolicy,
	},
	StressBreathingRound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | StressBreathingRoundKeySpecifier | (() => undefined | StressBreathingRoundKeySpecifier),
		fields?: StressBreathingRoundFieldPolicy,
	},
	Subscription?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SubscriptionKeySpecifier | (() => undefined | SubscriptionKeySpecifier),
		fields?: SubscriptionFieldPolicy,
	},
	Supportee?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupporteeKeySpecifier | (() => undefined | SupporteeKeySpecifier),
		fields?: SupporteeFieldPolicy,
	},
	Supporter?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupporterKeySpecifier | (() => undefined | SupporterKeySpecifier),
		fields?: SupporterFieldPolicy,
	},
	SupporterToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | SupporterTokenKeySpecifier | (() => undefined | SupporterTokenKeySpecifier),
		fields?: SupporterTokenFieldPolicy,
	},
	TextItem?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TextItemKeySpecifier | (() => undefined | TextItemKeySpecifier),
		fields?: TextItemFieldPolicy,
	},
	ThoughtDiaryEntry?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThoughtDiaryEntryKeySpecifier | (() => undefined | ThoughtDiaryEntryKeySpecifier),
		fields?: ThoughtDiaryEntryFieldPolicy,
	},
	ThoughtDiaryEntryPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThoughtDiaryEntryPracticeKeySpecifier | (() => undefined | ThoughtDiaryEntryPracticeKeySpecifier),
		fields?: ThoughtDiaryEntryPracticeFieldPolicy,
	},
	ThoughtDiaryEntrySpotAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThoughtDiaryEntrySpotActionKeySpecifier | (() => undefined | ThoughtDiaryEntrySpotActionKeySpecifier),
		fields?: ThoughtDiaryEntrySpotActionFieldPolicy,
	},
	ThoughtDiaryEntrySwitchAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThoughtDiaryEntrySwitchActionKeySpecifier | (() => undefined | ThoughtDiaryEntrySwitchActionKeySpecifier),
		fields?: ThoughtDiaryEntrySwitchActionFieldPolicy,
	},
	ThoughtDiaryEntryTestAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThoughtDiaryEntryTestActionKeySpecifier | (() => undefined | ThoughtDiaryEntryTestActionKeySpecifier),
		fields?: ThoughtDiaryEntryTestActionFieldPolicy,
	},
	ThoughtDiaryWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ThoughtDiaryWidgetKeySpecifier | (() => undefined | ThoughtDiaryWidgetKeySpecifier),
		fields?: ThoughtDiaryWidgetFieldPolicy,
	},
	Token?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TokenKeySpecifier | (() => undefined | TokenKeySpecifier),
		fields?: TokenFieldPolicy,
	},
	TrialPatientAssignment?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | TrialPatientAssignmentKeySpecifier | (() => undefined | TrialPatientAssignmentKeySpecifier),
		fields?: TrialPatientAssignmentFieldPolicy,
	},
	UpdateActivityPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateActivityPracticePayloadKeySpecifier | (() => undefined | UpdateActivityPracticePayloadKeySpecifier),
		fields?: UpdateActivityPracticePayloadFieldPolicy,
	},
	UpdateHopeKitImagePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateHopeKitImagePayloadKeySpecifier | (() => undefined | UpdateHopeKitImagePayloadKeySpecifier),
		fields?: UpdateHopeKitImagePayloadFieldPolicy,
	},
	UpdateHopeKitQuotePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateHopeKitQuotePayloadKeySpecifier | (() => undefined | UpdateHopeKitQuotePayloadKeySpecifier),
		fields?: UpdateHopeKitQuotePayloadFieldPolicy,
	},
	UpdateHopeKitVideoPayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateHopeKitVideoPayloadKeySpecifier | (() => undefined | UpdateHopeKitVideoPayloadKeySpecifier),
		fields?: UpdateHopeKitVideoPayloadFieldPolicy,
	},
	UpdatePracticeResult?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdatePracticeResultKeySpecifier | (() => undefined | UpdatePracticeResultKeySpecifier),
		fields?: UpdatePracticeResultFieldPolicy,
	},
	UpdateRelaxDiaryEntryPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateRelaxDiaryEntryPracticePayloadKeySpecifier | (() => undefined | UpdateRelaxDiaryEntryPracticePayloadKeySpecifier),
		fields?: UpdateRelaxDiaryEntryPracticePayloadFieldPolicy,
	},
	UpdateSleepDiaryEntryPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateSleepDiaryEntryPracticePayloadKeySpecifier | (() => undefined | UpdateSleepDiaryEntryPracticePayloadKeySpecifier),
		fields?: UpdateSleepDiaryEntryPracticePayloadFieldPolicy,
	},
	UpdateThoughtDiaryEntryPracticePayload?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UpdateThoughtDiaryEntryPracticePayloadKeySpecifier | (() => undefined | UpdateThoughtDiaryEntryPracticePayloadKeySpecifier),
		fields?: UpdateThoughtDiaryEntryPracticePayloadFieldPolicy,
	},
	UploadSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UploadSessionKeySpecifier | (() => undefined | UploadSessionKeySpecifier),
		fields?: UploadSessionFieldPolicy,
	},
	UsageInterval?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsageIntervalKeySpecifier | (() => undefined | UsageIntervalKeySpecifier),
		fields?: UsageIntervalFieldPolicy,
	},
	UsageSummary?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UsageSummaryKeySpecifier | (() => undefined | UsageSummaryKeySpecifier),
		fields?: UsageSummaryFieldPolicy,
	},
	User?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserKeySpecifier | (() => undefined | UserKeySpecifier),
		fields?: UserFieldPolicy,
	},
	UserAddress?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAddressKeySpecifier | (() => undefined | UserAddressKeySpecifier),
		fields?: UserAddressFieldPolicy,
	},
	UserAttributes?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserAttributesKeySpecifier | (() => undefined | UserAttributesKeySpecifier),
		fields?: UserAttributesFieldPolicy,
	},
	UserDemo?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDemoKeySpecifier | (() => undefined | UserDemoKeySpecifier),
		fields?: UserDemoFieldPolicy,
	},
	UserDisabledError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserDisabledErrorKeySpecifier | (() => undefined | UserDisabledErrorKeySpecifier),
		fields?: UserDisabledErrorFieldPolicy,
	},
	UserEmail?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserEmailKeySpecifier | (() => undefined | UserEmailKeySpecifier),
		fields?: UserEmailFieldPolicy,
	},
	UserName?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserNameKeySpecifier | (() => undefined | UserNameKeySpecifier),
		fields?: UserNameFieldPolicy,
	},
	UserSession?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSessionKeySpecifier | (() => undefined | UserSessionKeySpecifier),
		fields?: UserSessionFieldPolicy,
	},
	UserSessionToken?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSessionTokenKeySpecifier | (() => undefined | UserSessionTokenKeySpecifier),
		fields?: UserSessionTokenFieldPolicy,
	},
	UserSettings?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | UserSettingsKeySpecifier | (() => undefined | UserSettingsKeySpecifier),
		fields?: UserSettingsFieldPolicy,
	},
	ValidationError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidationErrorKeySpecifier | (() => undefined | ValidationErrorKeySpecifier),
		fields?: ValidationErrorFieldPolicy,
	},
	ValidationFieldError?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | ValidationFieldErrorKeySpecifier | (() => undefined | ValidationFieldErrorKeySpecifier),
		fields?: ValidationFieldErrorFieldPolicy,
	},
	Video?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | VideoKeySpecifier | (() => undefined | VideoKeySpecifier),
		fields?: VideoFieldPolicy,
	},
	Widget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WidgetKeySpecifier | (() => undefined | WidgetKeySpecifier),
		fields?: WidgetFieldPolicy,
	},
	WordPairing?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WordPairingKeySpecifier | (() => undefined | WordPairingKeySpecifier),
		fields?: WordPairingFieldPolicy,
	},
	WordPairingAction?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WordPairingActionKeySpecifier | (() => undefined | WordPairingActionKeySpecifier),
		fields?: WordPairingActionFieldPolicy,
	},
	WordPairingLevel?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WordPairingLevelKeySpecifier | (() => undefined | WordPairingLevelKeySpecifier),
		fields?: WordPairingLevelFieldPolicy,
	},
	WordPairingPractice?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WordPairingPracticeKeySpecifier | (() => undefined | WordPairingPracticeKeySpecifier),
		fields?: WordPairingPracticeFieldPolicy,
	},
	WordPairingRound?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WordPairingRoundKeySpecifier | (() => undefined | WordPairingRoundKeySpecifier),
		fields?: WordPairingRoundFieldPolicy,
	},
	WordPairingWidget?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | WordPairingWidgetKeySpecifier | (() => undefined | WordPairingWidgetKeySpecifier),
		fields?: WordPairingWidgetFieldPolicy,
	},
	YstGuardianProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstGuardianProfileKeySpecifier | (() => undefined | YstGuardianProfileKeySpecifier),
		fields?: YstGuardianProfileFieldPolicy,
	},
	YstInvite?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstInviteKeySpecifier | (() => undefined | YstInviteKeySpecifier),
		fields?: YstInviteFieldPolicy,
	},
	YstNomination?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstNominationKeySpecifier | (() => undefined | YstNominationKeySpecifier),
		fields?: YstNominationFieldPolicy,
	},
	YstNominationStatus?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstNominationStatusKeySpecifier | (() => undefined | YstNominationStatusKeySpecifier),
		fields?: YstNominationStatusFieldPolicy,
	},
	YstOrganization?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstOrganizationKeySpecifier | (() => undefined | YstOrganizationKeySpecifier),
		fields?: YstOrganizationFieldPolicy,
	},
	YstPatientMessage?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstPatientMessageKeySpecifier | (() => undefined | YstPatientMessageKeySpecifier),
		fields?: YstPatientMessageFieldPolicy,
	},
	YstPatientMessagePreview?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstPatientMessagePreviewKeySpecifier | (() => undefined | YstPatientMessagePreviewKeySpecifier),
		fields?: YstPatientMessagePreviewFieldPolicy,
	},
	YstProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstProfileKeySpecifier | (() => undefined | YstProfileKeySpecifier),
		fields?: YstProfileFieldPolicy,
	},
	YstSupportProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstSupportProfileKeySpecifier | (() => undefined | YstSupportProfileKeySpecifier),
		fields?: YstSupportProfileFieldPolicy,
	},
	YstSupporterCheckin?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstSupporterCheckinKeySpecifier | (() => undefined | YstSupporterCheckinKeySpecifier),
		fields?: YstSupporterCheckinFieldPolicy,
	},
	YstSupporterEvent?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstSupporterEventKeySpecifier | (() => undefined | YstSupporterEventKeySpecifier),
		fields?: YstSupporterEventFieldPolicy,
	},
	YstYouthProfile?: Omit<TypePolicy, "fields" | "keyFields"> & {
		keyFields?: false | YstYouthProfileKeySpecifier | (() => undefined | YstYouthProfileKeySpecifier),
		fields?: YstYouthProfileFieldPolicy,
	}
};
export type TypedTypePolicies = StrictTypedTypePolicies & TypePolicies;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Action": [
      "ActivityAddAction",
      "ActivityRateAction",
      "BreathHoldingAction",
      "CopingCardAddAction",
      "CopingCardReviewAction",
      "EatingLogAddAction",
      "HopeKitAddAction",
      "HopeKitReviewAction",
      "HyperventilationAction",
      "MyPlanReviewAction",
      "RelaxAction",
      "SleepDiaryEntryMorningAction",
      "SleepDiaryEntryNightAction",
      "StaticAction",
      "ThoughtDiaryEntrySpotAction",
      "ThoughtDiaryEntrySwitchAction",
      "ThoughtDiaryEntryTestAction",
      "WordPairingAction"
    ],
    "BaseError": [
      "InvalidPasswordError",
      "OutdatedBotStateError",
      "SimpleError",
      "UserDisabledError",
      "ValidationError"
    ],
    "CareTeamEntity": [
      "Organization",
      "Practitioner"
    ],
    "HopeKitItem": [
      "HopeKitImage",
      "HopeKitQuote",
      "HopeKitVideo"
    ],
    "IPatientProfile": [
      "Patient",
      "PatientProfile"
    ],
    "LegacyQuizSetItem": [
      "LegacyQuizSetItemMultipleChoiceQuestion",
      "LegacyQuizSetItemSingleChoiceQuestion",
      "LegacyQuizSetItemVideo"
    ],
    "MutationAcceptYstNominationResult": [
      "SimpleError",
      "YstNomination"
    ],
    "MutationAddEatingCheckinResult": [
      "EatingCheckinPractice",
      "SimpleError"
    ],
    "MutationAddEatingProgressEntryResult": [
      "EatingProgressEntryPractice",
      "SimpleError"
    ],
    "MutationAddYstSupporterEventResult": [
      "SimpleError",
      "YstSupportProfile"
    ],
    "MutationCreateJobResult": [
      "Job",
      "SimpleError",
      "ValidationError"
    ],
    "MutationCreateTestScenarioResult": [
      "CreateTestScenarioResult",
      "SimpleError",
      "ValidationError"
    ],
    "MutationDeclineYstNominationResult": [
      "SimpleError",
      "YstNomination"
    ],
    "MutationInviteYSTGuardianResult": [
      "Patient",
      "SimpleError",
      "ValidationError"
    ],
    "MutationInviteYSTYouthResult": [
      "Patient",
      "SimpleError",
      "ValidationError"
    ],
    "MutationLoginWithEmailResult": [
      "InvalidPasswordError",
      "SimpleError",
      "UserDisabledError",
      "UserSession"
    ],
    "MutationLoginWithTokenResult": [
      "InvalidPasswordError",
      "SimpleError",
      "UserDisabledError",
      "UserSession"
    ],
    "MutationNominateYstSupportersResult": [
      "MutationNominateYstSupportersSuccess",
      "SimpleError",
      "ValidationError"
    ],
    "MutationPersistBotStateResult": [
      "BotState",
      "OutdatedBotStateError",
      "SimpleError"
    ],
    "MutationPreviewYstPatientMessageResult": [
      "SimpleError",
      "YstPatientMessagePreview"
    ],
    "MutationRateYstSupporterCheckinResult": [
      "SimpleError",
      "YstSupporterCheckin"
    ],
    "MutationResendYstNominationInviteResult": [
      "SimpleError",
      "ValidationError",
      "YstNomination"
    ],
    "MutationResendYstPatientMessageResult": [
      "MutationResendYstPatientMessageSuccess",
      "SimpleError"
    ],
    "MutationSignupYSTGuardianResult": [
      "Patient",
      "SimpleError",
      "ValidationError"
    ],
    "MutationSignupYSTYouthResult": [
      "Patient",
      "SimpleError",
      "ValidationError"
    ],
    "MutationUpdateEatingCheckinResult": [
      "EatingCheckinPractice",
      "SimpleError"
    ],
    "MutationUpdateEatingProgressEntryResult": [
      "EatingProgressEntryPractice",
      "SimpleError"
    ],
    "MutationUpdateFirstCheckinDateResult": [
      "MutationUpdateFirstCheckinDateSuccess",
      "SimpleError",
      "ValidationError"
    ],
    "MutationUpdateOnboardingAvailabilityResult": [
      "MutationUpdateOnboardingAvailabilitySuccess",
      "SimpleError"
    ],
    "MutationUpdateOuiUserResult": [
      "CurrentOuiUser",
      "InvalidPasswordError",
      "SimpleError",
      "ValidationError"
    ],
    "MutationUpdatePracticeResult": [
      "SimpleError",
      "UpdatePracticeResult"
    ],
    "MutationUpdateRecurringAvailabilityResult": [
      "MutationUpdateRecurringAvailabilitySuccess",
      "SimpleError"
    ],
    "MutationUpdateYstMentalHealthConcernsResult": [
      "MutationUpdateYstMentalHealthConcernsSuccess",
      "SimpleError"
    ],
    "MutationUpdateYstSupporterEventResult": [
      "SimpleError",
      "YstSupportProfile"
    ],
    "OrganizationProductConfig": [
      "OrganizationAvivaConfig",
      "OrganizationYstConfig"
    ],
    "OuiUserType": [
      "OuiAdmin",
      "Patient",
      "Practitioner",
      "Registrar"
    ],
    "PendingAction": [
      "PendingActivityAddAction",
      "PendingActivityRateAction",
      "PendingBreathHoldingAction",
      "PendingCopingCardAddAction",
      "PendingCopingCardReviewAction",
      "PendingEatingLogAddAction",
      "PendingHopeKitAddAction",
      "PendingHopeKitReviewAction",
      "PendingHyperventilationAction",
      "PendingMyPlanReviewAction",
      "PendingRelaxAction",
      "PendingSleepDiaryEntryMorningAction",
      "PendingSleepDiaryEntryNightAction",
      "PendingThoughtDiaryEntrySpotAction",
      "PendingThoughtDiaryEntrySwitchAction",
      "PendingThoughtDiaryEntryTestAction",
      "PendingWordPairingAction"
    ],
    "Practice": [
      "ActivityPractice",
      "BreathHoldingPractice",
      "EatingCheckinPractice",
      "EatingCommitmentEntryPractice",
      "EatingLogEntryPractice",
      "EatingProgressEntryPractice",
      "HyperventilationPractice",
      "RelaxDiaryEntryPractice",
      "SleepDiaryEntryPractice",
      "ThoughtDiaryEntryPractice",
      "WordPairingPractice"
    ],
    "QuizSetItem": [
      "QuizSetItemChoice",
      "QuizSetItemVideo"
    ],
    "RoleProductConfig": [
      "RoleAvivaConfig",
      "RolePtsdConfig"
    ],
    "RoleSettings": [
      "ChangeBiteRoleSettings"
    ],
    "Widget": [
      "ActivityDiaryWidget",
      "BingeEatingMyPlanWidget",
      "BreathHoldingWidget",
      "CopingCardsWidget",
      "EatingLogWidget",
      "HopeKitWidget",
      "HyperventilationWidget",
      "MyPlanWidget",
      "RelaxDiaryWidget",
      "SleepDiaryWidget",
      "ThoughtDiaryWidget",
      "WordPairingWidget"
    ],
    "YstProfile": [
      "YstGuardianProfile",
      "YstSupportProfile",
      "YstYouthProfile"
    ],
    "YstSupporterActivity": [
      "YstSupporterCheckin",
      "YstSupporterEvent"
    ]
  }
};
      export default result;
    